import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/authcontext'
import OwnerOccupancy from './owneroccupancy'
import OwnerRevenue from './ownerrevenue'
import OwnerComplaints from './ownercomplaints'
import OwnerCompliance from './ownercompliance'
import AddTenantModal from './addtenantmodal'
// import AddTenantModal from './addtenantmodalnew'
import AddPGModal from './addpgmodal'
import AddRoomModal from './AddRoomModal'
import AddBedModal from './AddBedModal'
import {
  CreateUser,
  get_owner_dashboard,
  get_owner_pg_list,
  getNewTenantList,
  getRentCalculate,
  getVacantBeds,
  roommaster_SelectByPGID,
  updateRentAndBed,
  searchTenantsForPG,
  getExpenseTypes,
  saveTenantExpense,
  saveDailyFoodMenu,
  saveFoodMenuTemplate,
  getTodayFoodMenu,
  getWeeklyFoodMenu,
  insertSecurityDeposit,
  createRentAgreement,
} from '../apis/services/pgApi'
import AddElectricityReadingModal from './AddElectricityReadingModal';
import AddPGPhotosModal from './AddPGPhotosModal'
import { encryptData } from '../utils/crypto'
import * as environment from '../apis/env_config/environment'
import OwnerPlanning from './ownerplanning';
import PGLayoutModal from './pglayoutmodal';
import OwnerReports from './ownerreports'
// import AgreementModal from './AgreementModal'


// // Get user role from localStorage
// const userRole = parseInt(localStorage.getItem('userRole')) || 2;

// // Role checks
// const isStaff = userRole === 4;
// const isSupportingStaff = userRole === 5;
// const isOwner = userRole === 2;


// // Function to filter nav tabs based on role
// const getFilteredNavTabs = (originalTabs) => {
//   if (isOwner) return originalTabs;
//   if (isStaff) {
//     // For Staff: Remove Revenue and Compliance tabs
//     return originalTabs.filter(tab => tab.key !== 'revenue');
//   }
//   if (isSupportingStaff) {
//     // For Supporting Staff: Remove Occupancy, Revenue, Compliance tabs
//     return originalTabs.filter(tab => tab.key !== 'occupancy' && tab.key !== 'revenue' && tab.key !== 'compliance');
//   }
//   return originalTabs;
// };

// // Function to filter stats cards based on role
// const getFilteredStats = (originalStats) => {
//   if (isOwner) return originalStats;
//   if (isStaff) {
//     // For Staff: Remove Revenue and Compliance cards
//     return originalStats.filter(stat => stat.key !== 'revenue' );
//   }
//   if (isSupportingStaff) {
//     // For Supporting Staff: Remove Occupancy, Revenue, Compliance cards
//     return originalStats.filter(stat => stat.key !== 'occupancy' && stat.key !== 'revenue' && stat.key !== 'compliance');
//   }
//   return originalStats;
// };


// // ─── Constants ────────────────────────────────────────────────────
// const VACANT_ROOMS = ["102", "104", "106", "202", "302", "303"];

// // const NAV_TABS = [
// //   { key: "dashboard", label: "Dashboard" },
// //   { key: "occupancy", label: "Occupancy" },
// //   { key: "revenue", label: "Revenue" },
// //   { key: "complaints", label: "Complaints" },
// //   { key: "compliance", label: "Compliance" },
// // ];

// // Only show Dashboard tab when no PG is registered
// const getNavTabs = (hasPG) => {
//   if (!hasPG) {
//     return [{ key: "dashboard", label: "Dashboard" }];
//   }
//   return [
//     { key: "dashboard", label: "Dashboard" },
//     { key: "occupancy", label: "Occupancy" },
//     { key: "revenue", label: "Revenue" },
//     { key: "complaints", label: "Complaints" },
//     { key: "compliance", label: "Compliance" },
//   ];
// };

// // Get quick actions based on whether PG exists
// const getQuickActions = (hasPG) => {
//   if (!hasPG) {
//     // Only show Add PG button when no PG exists
//     return ALL_QUICK_ACTIONS.filter(action => action.key === "add_pg");
//   }
//   // Show all actions when PG exists
//   return ALL_QUICK_ACTIONS;
// };

const formatDateToDDMMYYYY = (dateStr) => {
  if (!dateStr) return "";
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return "";
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  } catch (e) {
    return "";
  }
};

const EXPENSE_TYPE_OPTIONS = [
  "Maintenance",
  "Electricity",
  "Food & Groceries",
  "Repair",
  "Cleaning",
  "Delay Payment",
  "Other",
];

const DAY_OPTIONS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

// ─── Food Menu Modal ────────────────────────────────────
const getTodayIST = () => {
  const now = new Date();
  const ist = new Date(
    now.toLocaleString("en-US", {
      timeZone: "Asia/Kolkata",
    })
  );
  const yyyy = ist.getFullYear();
  const mm = String(ist.getMonth() + 1).padStart(2, "0");
  const dd = String(ist.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

const parseDate = (dateStr) => {
  if (!dateStr) return new Date();
  const [yyyy, mm, dd] = dateStr.split("-").map(Number);
  return new Date(yyyy, mm - 1, dd);
};

// Meal rows shown in the grid, top to bottom
const MEAL_TYPES = [
  { key: "breakfast", label: "Breakfast", icon: "🌅" },
  { key: "lunch", label: "Lunch", icon: "☀️" },
  { key: "tea", label: "Tea", icon: "🍵" },
  { key: "dinner", label: "Dinner", icon: "🌙" },
];

// const DAY_ABBR = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
// const DAY_FULL = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const DAY_ABBR = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const DAY_FULL = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

// Normalizes a stored meal value (string from legacy API, or array) into a clean items array
const toItemsArray = (val) => {
  if (Array.isArray(val)) return val.map((s) => String(s).trim()).filter(Boolean);
  if (typeof val === "string" && val.trim()) {
    return val
      .split(/\r?\n/)
      .map((s) => s.replace(/^\s*\d+[).]\s*/, "").trim())
      .filter(Boolean);
  }
  return [];
};

// Fixed column order: Monday first, Sunday last (Date#getDay(): 0=Sun..6=Sat)
const WEEKDAY_COLUMN_ORDER = [1, 2, 3, 4, 5, 6, 0];

const FoodMenuModal = ({ isOpen, onClose, selectedPG, onSubmit }) => {
  const [viewMode, setViewMode] = useState("weekly");
  const [singleDate, setSingleDate] = useState(getTodayIST);
  const [weekMenu, setWeekMenu] = useState([]);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [originalWeekMenu, setOriginalWeekMenu] = useState([]);

  const MAX_ITEMS = 4;

  // Add/Edit items popup state
  const [itemsModalOpen, setItemsModalOpen] = useState(false);
  const [activeCell, setActiveCell] = useState(null);
  const [tempItems, setTempItems] = useState([""]);

  // Fetch weekly menu data when modal opens
  useEffect(() => {
    if (isOpen && selectedPG) {
      fetchWeeklyMenu();
    }
  }, [isOpen, selectedPG]);

  // Fetch single day data when date changes in single view
  useEffect(() => {
    if (isOpen && viewMode === 'single' && selectedPG && singleDate) {
      fetchSingleDayMenu(singleDate);
    }
  }, [isOpen, viewMode, singleDate, selectedPG]);

  const fetchWeeklyMenu = async () => {
    if (!selectedPG?.PGID) return;

    setLoading(true);
    setError("");

    try {
      const today = getTodayIST();
      const response = await getWeeklyFoodMenu(selectedPG.PGID, today);
      console.log("Weekly menu response:", response);

      const todayDate = parseDate(today);
      const todayDow = todayDate.getDay();

      const mondayOffset = (todayDow === 0) ? -6 : 1 - todayDow;
      const mondayDate = new Date(todayDate);
      mondayDate.setDate(todayDate.getDate() + mondayOffset);

      const weekArray = [];
      const weekMap = {};

      for (let i = 0; i < 7; i++) {
        const date = new Date(mondayDate);
        date.setDate(mondayDate.getDate() + i);

        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        const dateStr = `${yyyy}-${mm}-${dd}`;
        const dayName = DAY_FULL[i];

        const dayData = {
          date: dateStr,
          day: DAY_ABBR[i],
          fullDay: dayName,
          isToday: dateStr === today,
          items: {
            breakfast: [],
            lunch: [],
            tea: [],
            dinner: [],
          },
          menuTemplateIds: {
            breakfast: null,
            lunch: null,
            tea: null,
            dinner: null,
          }
        };

        weekArray.push(dayData);
        weekMap[dateStr] = dayData;
        weekMap[dayName] = dayData;
      }

      if (response && response.data && response.data.weeklyMenu) {
        const weeklyData = response.data.weeklyMenu;

        weeklyData.forEach((item) => {
          const dayName = item.dayName;
          const mealType = item.mealType.toLowerCase();
          const dayData = weekMap[dayName];

          if (dayData) {
            const items = [];
            if (item.item1) items.push(item.item1);
            if (item.item2) items.push(item.item2);
            if (item.item3) items.push(item.item3);
            if (item.item4) items.push(item.item4);

            let mealKey = mealType;
            if (mealType === 'breakfast') mealKey = 'breakfast';
            else if (mealType === 'lunch') mealKey = 'lunch';
            else if (mealType === 'tea') mealKey = 'tea';
            else if (mealType === 'dinner') mealKey = 'dinner';

            dayData.items[mealKey] = items;
            dayData.menuTemplateIds[mealKey] = item.menuTemplateId;
          }
        });
      }

      setWeekMenu(weekArray);
      setOriginalWeekMenu(JSON.parse(JSON.stringify(weekArray)));

      const todayEntry = weekArray.find(d => d.isToday) || weekArray[0];
      if (todayEntry) {
        setSingleDate(todayEntry.date);
      }
    } catch (err) {
      console.error("Error fetching weekly menu:", err);
      setError("Failed to load weekly menu. Please try again.");
      generateEmptyWeek();
    } finally {
      setLoading(false);
    }
  };

  const generateEmptyWeek = () => {
    const today = getTodayIST();
    const todayDate = parseDate(today);
    const todayDow = todayDate.getDay();

    const mondayOffset = (todayDow === 0) ? -6 : 1 - todayDow;
    const mondayDate = new Date(todayDate);
    mondayDate.setDate(todayDate.getDate() + mondayOffset);

    const week = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(mondayDate);
      date.setDate(mondayDate.getDate() + i);

      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const dateStr = `${yyyy}-${mm}-${dd}`;

      week.push({
        date: dateStr,
        day: DAY_ABBR[i],
        fullDay: DAY_FULL[i],
        isToday: dateStr === today,
        items: {
          breakfast: [],
          lunch: [],
          tea: [],
          dinner: [],
        },
        menuTemplateIds: {
          breakfast: null,
          lunch: null,
          tea: null,
          dinner: null,
        }
      });
    }

    setWeekMenu(week);
    setOriginalWeekMenu(JSON.parse(JSON.stringify(week)));
  };

  const fetchSingleDayMenu = async (date) => {
    if (!selectedPG?.PGID || !date) return;

    setLoading(true);
    setError("");

    try {
      const response = await getTodayFoodMenu(selectedPG.PGID, date);
      console.log("Single day menu response:", response);

      setWeekMenu(prev => {
        return prev.map(day => {
          if (day.date === date) {
            const newItems = { ...day.items };

            if (response && response.data) {
              Object.keys(newItems).forEach(key => newItems[key] = []);

              response.data.forEach((item) => {
                const mealKey = item.mealType.toLowerCase();
                if (newItems[mealKey] !== undefined) {
                  const items = [];
                  if (item.item1) items.push(item.item1);
                  if (item.item2) items.push(item.item2);
                  if (item.item3) items.push(item.item3);
                  if (item.item4) items.push(item.item4);
                  newItems[mealKey] = items;
                }
              });
            }

            return { ...day, items: newItems };
          }
          return day;
        });
      });

    } catch (err) {
      console.error("Error fetching single day menu:", err);
      setError("Failed to load menu for this date. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Keep the Single Day selector pointed at a valid column
  useEffect(() => {
    if (weekMenu.length && !weekMenu.some((d) => d.date === singleDate)) {
      const todayEntry = weekMenu.find((d) => d.isToday) || weekMenu[0];
      setSingleDate(todayEntry?.date || weekMenu[0]?.date);
    }
  }, [weekMenu]);

  // ─── Add / Edit items popup ────────────────────────────────
  const openItemsModal = (date, mealKey) => {
    const day = weekMenu.find((d) => d.date === date);
    const existingItems = day?.items?.[mealKey] || [];
    setActiveCell({ date, mealKey });
    setTempItems(existingItems.length ? [...existingItems] : [""]);
    setItemsModalOpen(true);
  };

  const closeItemsModal = () => {
    setItemsModalOpen(false);
    setActiveCell(null);
    setTempItems([""]);
  };

  const addTempItemField = () => {
    if (tempItems.length >= MAX_ITEMS) {
      alert(`Maximum ${MAX_ITEMS} items allowed per meal.`);
      return;
    }
    setTempItems((prev) => [...prev, ""]);
  };

  const updateTempItem = (idx, value) => {
    setTempItems((prev) => {
      const updated = [...prev];
      updated[idx] = value;
      return updated;
    });
  };

  const removeTempItem = (idx) => {
    setTempItems((prev) => (prev.length > 1 ? prev.filter((_, i) => i !== idx) : prev));
  };

  const clearAllTempItems = () => {
    setTempItems([""]);
  };

  const saveTempItems = () => {
    if (!activeCell) return;
    const cleaned = tempItems.map((s) => s.trim()).filter(Boolean);
    // Filter out empty items and limit to MAX_ITEMS
    // let cleaned = tempItems.map((s) => s.trim()).filter(Boolean);
    // Only take first MAX_ITEMS items
    if (cleaned.length > MAX_ITEMS) {
      cleaned = cleaned.slice(0, MAX_ITEMS);
      alert(`Only first ${MAX_ITEMS} items will be saved.`);
    }
    setWeekMenu((prev) =>
      prev.map((d) =>
        d.date === activeCell.date
          ? { ...d, items: { ...d.items, [activeCell.mealKey]: cleaned } }
          : d
      )
    );
    closeItemsModal();
  };

  // Helper function to check if two item arrays are different
  const areItemsDifferent = (items1, items2) => {
    if (!items1 && !items2) return false;
    if (!items1 || !items2) return true;
    if (items1.length !== items2.length) return true;
    for (let i = 0; i < items1.length; i++) {
      if (items1[i] !== items2[i]) return true;
    }
    return false;
  };

  // Helper function to get changed meals for weekly view
  const getChangedWeeklyMeals = () => {
    const changedMeals = [];

    weekMenu.forEach((day, dayIndex) => {
      const originalDay = originalWeekMenu[dayIndex];
      if (!originalDay) return;

      MEAL_TYPES.forEach((meal) => {
        const currentItems = day.items[meal.key] || [];
        const originalItems = originalDay.items[meal.key] || [];

        if (areItemsDifferent(currentItems, originalItems)) {
          changedMeals.push({
            dayNo: DAY_FULL.indexOf(day.fullDay) + 1,
            dayName: day.fullDay,
            mealType: meal.label,
            menuTemplateId: day.menuTemplateIds?.[meal.key] || null,
            items: currentItems,
            date: day.date,
            mealKey: meal.key
          });
        }
      });
    });

    return changedMeals;
  };

  // Helper function to get changed meals for single day view
  const getChangedSingleDayMeals = () => {
    const day = weekMenu.find(d => d.date === singleDate);
    if (!day) return [];

    const originalDay = originalWeekMenu.find(d => d.date === singleDate);
    if (!originalDay) {
      const changedMeals = [];
      MEAL_TYPES.forEach((meal) => {
        const items = day.items[meal.key] || [];
        if (items.length > 0) {
          changedMeals.push({
            mealType: meal.label,
            items: items,
            mealKey: meal.key
          });
        }
      });
      return changedMeals;
    }

    const changedMeals = [];
    MEAL_TYPES.forEach((meal) => {
      const currentItems = day.items[meal.key] || [];
      const originalItems = originalDay.items[meal.key] || [];

      if (areItemsDifferent(currentItems, originalItems)) {
        changedMeals.push({
          mealType: meal.label,
          items: currentItems,
          mealKey: meal.key
        });
      }
    });

    return changedMeals;
  };

  if (!isOpen) return null;

  const handleClose = () => {
    setError("");
    onClose();
  };

  const handleSubmit = async () => {
    const hasMeal = weekMenu.some((day) =>
      Object.values(day.items).some((arr) => arr.length > 0)
    );

    if (!hasMeal) {
      setError("Please add at least one item for the week");
      return;
    }

    setError("");
    setSubmitting(true);

    try {
      if (viewMode === 'weekly') {
        const changedMeals = getChangedWeeklyMeals();

        if (changedMeals.length === 0) {
          alert("No changes detected to save.");
          onClose();
          return;
        }

        console.log("Changed meals to save:", changedMeals);

        for (const item of changedMeals) {
          const payload = {
            MenutemplateId: item.menuTemplateId,
            PGID: selectedPG.PGID,
            DayNo: item.dayNo,
            MealType: item.mealType,
            Item1: item.items[0] || null,
            Item2: item.items[1] || null,
            Item3: item.items[2] || null,
            Item4: item.items[3] || null,
            IsVeg: true,
            Remarks: null,
            UserID: parseInt(localStorage.getItem('userId')) || 1
          };

          console.log(`Saving ${item.dayName} - ${item.mealType}:`, payload);
          await saveFoodMenuTemplate(payload);
        }

        alert(`Weekly menu saved successfully! ${changedMeals.length} item(s) updated.`);
        onClose();
      } else {
        const changedMeals = getChangedSingleDayMeals();

        if (changedMeals.length === 0) {
          alert("No changes detected to save.");
          onClose();
          return;
        }

        console.log("Changed meals to save (single day):", changedMeals);

        const day = weekMenu.find(d => d.date === singleDate);
        if (day) {
          for (const item of changedMeals) {
            const payload = {
              PGID: selectedPG.PGID,
              MenuDate: singleDate,
              MealType: item.mealType,
              Item1: item.items[0] || null,
              Item2: item.items[1] || null,
              Item3: item.items[2] || null,
              Item4: item.items[3] || null,
              IsVeg: true,
              IsSpecialMenu: false,
              Remarks: null
            };

            console.log(`Saving ${day.fullDay} - ${item.mealType}:`, payload);
            await saveDailyFoodMenu(payload);
          }

          alert(`Daily menu saved successfully! ${changedMeals.length} item(s) updated.`);
          onClose();
        }
      }

      if (onSubmit) {
        await onSubmit(weekMenu);
      }
    } catch (err) {
      console.error("Error saving food menu:", err);
      setError("Failed to save food menu. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  // Renders a single meal cell
  const renderMealCell = (day, mealKey) => {
    const items = day.items?.[mealKey] || [];
    return (
      <div className="rv-food-cell-inner">
        {items.length > 0 ? (
          <>
            <ol className="rv-food-items-list">
              {items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ol>
            <button
              type="button"
              className="rv-food-edit-btn"
              onClick={() => openItemsModal(day.date, mealKey)}
            >
              ✎ Edit
            </button>
          </>
        ) : (
          <button
            type="button"
            className="rv-food-add-btn"
            onClick={() => openItemsModal(day.date, mealKey)}
          >
            + Add Items
          </button>
        )}
      </div>
    );
  };

  const renderSingleDayView = () => {
    const day = weekMenu.find((d) => d.date === singleDate);

    return (
      <div className="rv-food-single">
        <div className="rv-owner-field" style={{ marginBottom: '16px' }}>
          <label className="rv-owner-label">Day</label>
          <select
            className="rv-owner-select"
            value={singleDate}
            onChange={(e) => {
              setSingleDate(e.target.value);
              fetchSingleDayMenu(e.target.value);
            }}
          >
            {weekMenu.map((d) => (
              <option key={d.date} value={d.date}>
                {d.fullDay} ({formatDateToDDMMYYYY(d.date)}){d.isToday ? " · Today" : ""}
              </option>
            ))}
          </select>
        </div>
        {day && (
          <div className="rv-food-single-meals">
            {MEAL_TYPES.map((meal) => (
              <div className="rv-food-single-meal-row" key={meal.key}>
                <div className="rv-food-single-meal-label">
                  <span>{meal.icon}</span> {meal.label}
                </div>
                {renderMealCell(day, meal.key)}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const renderWeeklyTableView = () => (
    <div className="rv-food-table-wrapper">
      <table className="rv-food-table rv-food-grid-table">
        <thead>
          <tr>
            <th className="rv-food-meal-header">Meal</th>
            {weekMenu.map((day) => (
              <th key={day.date} className={day.isToday ? 'today' : ''}>
                <span className="rv-food-th-day">{day.day}</span>
                {day.isToday ? (
                  <span className="rv-today-badge rv-today-badge-sm">Today</span>
                ) : (
                  // <span className="rv-food-th-date">{formatDateToDDMMYYYY(day.date)}</span>
                  null
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {MEAL_TYPES.map((meal) => (
            <tr key={meal.key} className="rv-food-meal-row">
              <td className="rv-food-meal-label">
                <span>{meal.icon}</span> {meal.label}
              </td>
              {weekMenu.map((day) => (
                <td key={day.date} className={`rv-food-cell ${day.isToday ? 'today' : ''}`}>
                  {renderMealCell(day, meal.key)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderMobileCardView = () => (
    <div className="rv-food-mobile">
      {weekMenu.map((day) => (
        <div key={day.date} className={`rv-food-card ${day.isToday ? 'today' : ''}`}>
          <div className="rv-food-card-header">
            <div>
              <span className="rv-food-card-day">{day.day}</span>
              {day.isToday && <span className="rv-today-badge rv-today-badge-sm">Today</span>}
            </div>
            <span className="rv-food-card-date">{formatDateToDDMMYYYY(day.date)}</span>
          </div>
          <div className="rv-food-card-body">
            {MEAL_TYPES.map((meal) => (
              <div className="rv-food-card-meal-row" key={meal.key}>
                <div className="rv-food-card-meal-label">
                  <span>{meal.icon}</span> {meal.label}
                </div>
                {renderMealCell(day, meal.key)}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );

  const activeDay = activeCell ? weekMenu.find((d) => d.date === activeCell.date) : null;
  const activeMeal = activeCell ? MEAL_TYPES.find((m) => m.key === activeCell.mealKey) : null;

  return (
    <>
      <div className="rv-overlay" onClick={handleClose}>
        <div className="rv-modal rv-food-modal" onClick={(e) => e.stopPropagation()}>
          {/* Header */}
          <div className="rv-head rv-food-head">
            <div>
              <h2 className="rv-title">Weekly Food Menu</h2>
              <p className="rv-sub">{selectedPG?.PGName || "Plan meals for upcoming days"}</p>
            </div>
            <button className="rv-close" onClick={handleClose}>
              <svg width="15" height="15" viewBox="0 0 18 18" fill="none">
                <path d="M1 1L17 17M17 1L1 17" stroke="#374151" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </button>
          </div>

          <div className="rv-body rv-food-body">
            {/* Toolbar */}
            <div className="rv-food-toolbar">
              <span className="rv-food-days-count">
                📅 Monday – Sunday · today's column is highlighted
              </span>
            </div>

            {/* View Toggle */}
            <div className="rv-food-toggle">
              <button
                className={`rv-food-toggle-btn ${viewMode === 'weekly' ? 'active' : ''}`}
                onClick={() => {
                  setViewMode('weekly');
                }}
              >
                📅 Weekly Planner
              </button>
              <button
                className={`rv-food-toggle-btn ${viewMode === 'single' ? 'active' : ''}`}
                onClick={() => {
                  setViewMode('single');
                  if (singleDate) fetchSingleDayMenu(singleDate);
                }}
              >
                📆 Single Day
              </button>
            </div>

            {loading && (
              <div className="rv-loading-state">
                <div className="rv-spinner"></div>
                <p>Loading menu...</p>
              </div>
            )}

            {!loading && viewMode === 'weekly' && (
              <>
                <div className="rv-food-desktop">
                  {renderWeeklyTableView()}
                </div>
                <div className="rv-food-mobile-view">
                  {renderMobileCardView()}
                </div>
              </>
            )}

            {!loading && viewMode === 'single' && renderSingleDayView()}

            {error && (
              <p className="rv-error" style={{ color: '#DC2626', fontSize: '12px', marginTop: '12px' }}>
                {error}
              </p>
            )}
          </div>

          <div className="rv-footer">
            <button className="rv-btn rv-btn-outline" onClick={handleClose}>
              Cancel
            </button>
            <button className="rv-btn rv-btn-verify" disabled={submitting || loading} onClick={handleSubmit}>
              {submitting ? "Saving…" : "Save Menu"}
            </button>
          </div>
        </div>
      </div>

      {/* Add / Edit items popup */}
      {itemsModalOpen && activeCell && (
        <div className="rv-overlay rv-overlay-nested" onClick={closeItemsModal}>
          <div className="rv-modal rv-modal-sm rv-items-modal" onClick={(e) => e.stopPropagation()}>
            <div className="rv-head">
              <div>
                <h2 className="rv-title">
                  {activeDay?.fullDay || activeDay?.day} - {activeMeal?.label}
                </h2>
                <p className="rv-sub">{formatDateToDDMMYYYY(activeCell.date)}</p>
              </div>
              <button className="rv-close" onClick={closeItemsModal}>
                <svg width="15" height="15" viewBox="0 0 18 18" fill="none">
                  <path d="M1 1L17 17M17 1L1 17" stroke="#374151" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </button>
            </div>

            <div className="rv-body">
              <div className="rv-items-edit-list">
                {tempItems.map((item, idx) => (
                  <div className="rv-item-edit-row" key={idx}>
                    <span className="rv-item-edit-index">{idx + 1}</span>
                    <input
                      type="text"
                      className="rv-owner-input"
                      placeholder={`Item ${idx + 1} (e.g. Poha)`}
                      value={item}
                      autoFocus={idx === tempItems.length - 1}
                      onChange={(e) => updateTempItem(idx, e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          addTempItemField();
                        }
                      }}
                    />
                    {tempItems.length > 1 && (
                      <button
                        type="button"
                        className="rv-item-remove-btn"
                        onClick={() => removeTempItem(idx)}
                        aria-label="Remove item"
                      >
                        ×
                      </button>
                    )}
                  </div>
                ))}
              </div>
              <div className="rv-items-popup-actions">
                <button type="button" className="rv-add-item-btn" onClick={addTempItemField}>
                  + Add Item
                </button>
                <button type="button" className="rv-clear-all-btn" onClick={clearAllTempItems}>
                  🗑 Clear All
                </button>
              </div>
            </div>

            <div className="rv-footer">
              <button className="rv-btn rv-btn-outline" onClick={closeItemsModal}>
                Cancel
              </button>
              <button className="rv-btn rv-btn-verify" onClick={saveTempItems}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};


const AddExpenseModal = ({ isOpen, onClose, selectedPG, onSuccess }) => {
  // Form states
  const [tenantId, setTenantId] = useState("");
  const [expenseType, setExpenseType] = useState("");
  const [otherExpenseType, setOtherExpenseType] = useState("");
  const [date, setDate] = useState(() => getTodayIST());
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [staffName, setStaffName] = useState("");

  // UI states
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);

  // Data states
  const [tenantList, setTenantList] = useState([]);
  const [loadingTenants, setLoadingTenants] = useState(false);
  const [expenseTypes, setExpenseTypes] = useState([]);
  const [loadingTypes, setLoadingTypes] = useState(false);

  // Expense type options (fallback if API fails)
  const EXPENSE_TYPE_OPTIONS = [
    { ExpenseTypeID: 1, ExpenseTypeName: "Maintenance" },
    { ExpenseTypeID: 2, ExpenseTypeName: "Electricity" },
    { ExpenseTypeID: 3, ExpenseTypeName: "Food & Groceries" },
    { ExpenseTypeID: 4, ExpenseTypeName: "Repair" },
    { ExpenseTypeID: 5, ExpenseTypeName: "Cleaning" },
    { ExpenseTypeID: 6, ExpenseTypeName: "Other" }
  ];

  // Fetch data when modal opens
  useEffect(() => {
    if (isOpen && selectedPG) {
      fetchTenants();
      fetchExpenseTypes();
    }
  }, [isOpen, selectedPG]);

  // Fetch tenants from API
  const fetchTenants = async () => {
    setLoadingTenants(true);
    setError("");
    try {
      const response = await searchTenantsForPG(selectedPG?.PGID);
      console.log("Tenants response:", response);

      if (response && response.data && response.data.length > 0) {
        setTenantList(response.data);
      } else {
        setTenantList([]);
        setError("No active tenants found for this PG");
      }
    } catch (err) {
      console.error("Error fetching tenants:", err);
      setError("Failed to load tenants. Please try again.");
      setTenantList([]);
    } finally {
      setLoadingTenants(false);
    }
  };

  // Fetch expense types from API or use fallback
  const fetchExpenseTypes = async () => {
    setLoadingTypes(true);
    try {
      // Try to fetch from API first
      const response = await getExpenseTypes();
      if (response && response.data && response.data.length > 0) {
        setExpenseTypes(response.data);
      } else {
        // Use fallback options
        setExpenseTypes(EXPENSE_TYPE_OPTIONS);
      }
    } catch (err) {
      console.error("Error fetching expense types:", err);
      // Use fallback options
      setExpenseTypes(EXPENSE_TYPE_OPTIONS);
    } finally {
      setLoadingTypes(false);
    }
  };

  if (!isOpen) return null;

  const resetForm = () => {
    setTenantId("");
    setExpenseType("");
    setOtherExpenseType("");
    setDate(getTodayIST());
    setDescription("");
    setAmount("");
    setStaffName("");
    setError("");
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSubmit = async () => {
    // Validations
    if (!tenantId) {
      setError("Please select a tenant");
      return;
    }
    if (!expenseType) {
      setError("Please select an expense type");
      return;
    }
    if (expenseType === "Other" && !otherExpenseType.trim()) {
      setError("Please specify the expense type");
      return;
    }
    if (!date) {
      setError("Please select a date");
      return;
    }
    if (!amount || parseFloat(amount) <= 0) {
      setError("Please enter a valid amount");
      return;
    }
    if (!staffName.trim()) {
      setError("Please enter staff name");
      return;
    }

    // Get selected tenant details
    const selectedTenant = tenantList.find(t => String(t.tenantId) === String(tenantId));

    // Get user ID from localStorage
    const userId = parseInt(localStorage.getItem('userId')) || 1;
    const userRole = parseInt(localStorage.getItem('userRole')) || 2;

    // Prepare payload for API
    const expenseTypeName = expenseType === "Other" ? otherExpenseType.trim() : expenseType;
    const expenseTypeId = getExpenseTypeId(expenseTypeName);

    const payload = {
      PGID: selectedPG?.PGID,
      TenantID: selectedTenant?.tenantId || null,
      AdmissionID: selectedTenant?.admissionId || null,
      ExpenseTypeID: expenseTypeId,
      ExpenseDate: date,
      Amount: parseFloat(amount),
      Description: description || null,
      StaffName: staffName.trim(),
      CreatedBy: userId
    };

    console.log("Expense payload:", payload);

    setError("");
    setSubmitting(true);

    try {
      // Call the API to save expense
      const response = await saveTenantExpense(payload);
      console.log("Expense saved successfully:", response);

      // Call onSuccess callback if provided
      if (onSuccess) {
        await onSuccess(response);
      }

      // Show success message
      alert("Expense saved successfully!");

      resetForm();
      onClose();
    } catch (err) {
      console.error("Error saving expense:", err);
      const errorMessage = err.response?.data?.message || err.message || "Failed to save expense. Please try again.";
      setError(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  // Helper function to get ExpenseTypeID
  const getExpenseTypeId = (typeName) => {
    const typeMap = {
      'Maintenance': 1,
      'Electricity': 2,
      'Food & Groceries': 3,
      'Repair': 4,
      'Cleaning': 5,
      'Other': 6
    };
    return typeMap[typeName] || 6; // Default to Other
  };

  // Get tenant display name
  const getTenantDisplayName = (tenant) => {
    if (!tenant) return "";
    return `${tenant.tenantName || 'Unknown'} · Room ${tenant.roomNumber || '—'} · Bed ${tenant.bedNumber || '—'}`;
  };

  return (
    <div className="rv-overlay" onClick={handleClose}>
      <div className="rv-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="rv-head">
          <div>
            <h2 className="rv-title">Add Expense</h2>
            <p className="rv-sub">{selectedPG?.PGName ? `For ${selectedPG.PGName}` : "Record a new expense"}</p>
          </div>
          <button className="rv-close" onClick={handleClose}>
            <svg width="15" height="15" viewBox="0 0 18 18" fill="none">
              <path d="M1 1L17 17M17 1L1 17" stroke="#374151" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        <div className="rv-body">
          {/* Tenant Selection */}
          <div className="rv-owner-field">
            <label className="rv-owner-label">Select Tenant</label>
            <select
              className="rv-owner-select"
              value={tenantId}
              onChange={(e) => setTenantId(e.target.value)}
              disabled={loadingTenants}
            >
              <option value="">
                {loadingTenants ? "Loading tenants..." : "Choose tenant…"}
              </option>
              {tenantList.map((tenant) => (
                <option key={tenant.tenantId} value={tenant.tenantId}>
                  {getTenantDisplayName(tenant)}
                </option>
              ))}
            </select>
            {tenantList.length === 0 && !loadingTenants && (
              <p style={{ color: '#6B7280', fontSize: '12px', marginTop: '4px' }}>
                No active tenants found. Please add tenants first.
              </p>
            )}
          </div>

          {/* Expense Type and Date */}
          <div className="rv-owner-grid" style={{ marginTop: '14px' }}>
            <div className="rv-owner-field">
              <label className="rv-owner-label">Expense Type</label>
              <select
                className="rv-owner-select"
                value={expenseType}
                onChange={(e) => setExpenseType(e.target.value)}
                disabled={loadingTypes}
              >
                <option value="">Choose type…</option>
                {expenseTypes.map((type) => (
                  <option key={type.ExpenseTypeID} value={type.ExpenseTypeName}>
                    {type.ExpenseTypeName}
                  </option>
                ))}
              </select>
            </div>
            <div className="rv-owner-field">
              <label className="rv-owner-label">Date</label>
              <input
                type="date"
                className="rv-owner-input"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                max={getTodayIST()}
              />
            </div>
          </div>

          {/* Other Expense Type Input */}
          {expenseType === "Other" && (
            <div className="rv-owner-field" style={{ marginTop: '14px' }}>
              <label className="rv-owner-label">Specify Expense Type</label>
              <input
                type="text"
                className="rv-owner-input"
                placeholder="e.g. Pest Control, Stationery, etc."
                value={otherExpenseType}
                onChange={(e) => setOtherExpenseType(e.target.value)}
              />
            </div>
          )}

          {/* Description */}
          <div className="rv-owner-field" style={{ marginTop: '14px' }}>
            <label className="rv-owner-label">Description</label>
            <textarea
              className="rv-owner-input"
              rows={3}
              style={{ resize: 'vertical', fontFamily: 'inherit' }}
              placeholder="Brief description of the expense (optional)"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

          {/* Amount and Staff Name */}
          <div className="rv-owner-grid" style={{ marginTop: '14px' }}>
            <div className="rv-owner-field">
              <label className="rv-owner-label">Amount (₹)</label>
              <input
                type="number"
                min="0"
                step="0.01"
                className="rv-owner-input"
                placeholder="e.g. 1500"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>
            <div className="rv-owner-field">
              <label className="rv-owner-label">Staff Name</label>
              <input
                type="text"
                className="rv-owner-input"
                placeholder="e.g. Suresh Kumar"
                value={staffName}
                onChange={(e) => setStaffName(e.target.value)}
              />
            </div>
          </div>

          {/* Error Message */}
          {error && (
            <p className="rv-error" style={{ color: '#DC2626', fontSize: '12px', marginTop: '12px' }}>
              {error}
            </p>
          )}
        </div>

        {/* Footer */}
        <div className="rv-footer">
          <button className="rv-btn rv-btn-outline" onClick={handleClose} disabled={submitting}>
            Cancel
          </button>
          <button
            className="rv-btn rv-btn-verify"
            disabled={submitting || loadingTenants}
            onClick={handleSubmit}
          >
            {submitting ? "Saving…" : "Save Expense"}
          </button>
        </div>
      </div>
    </div>
  );
};

// ─── Review Modal ─────────────────────────────────────────────────
const ReviewModal = ({ tenant, selectedPGId, onClose, onVerify, onAgreementCreated }) => {
  const [rentType, setRentType] = useState(tenant.RentType || "");
  const [rentAmount, setRentAmount] = useState(tenant.RentAmount || "");

  const convertToAPIRoomType = (displayType) => {
    if (!displayType) return '';
    const typeMap = {
      'SINGLE': 'Single',
      'DOUBLE': 'Double',
      'TRIPLE': 'Triple',
      'QUAD': 'Quad',
      'DORM': 'Dorm',
    };
    return typeMap[displayType] || displayType.toUpperCase();
  };

  const [roomType, setRoomType] = useState(convertToAPIRoomType(tenant.ROOMTYPE) || "");
  const [bedId, setBedId] = useState(tenant.BedID || "");
  const [vacantBeds, setVacantBeds] = useState([]);
  const [loadingBeds, setLoadingBeds] = useState(false);
  const [error, setError] = useState("");

  // New states for calculated rent and deposit
  const [calculatedRent, setCalculatedRent] = useState(null);
  const [calculatingRent, setCalculatingRent] = useState(false);
  const [deposit, setDeposit] = useState("");


  const [securityDepositAmount, setSecurityDepositAmount] = useState(tenant.SecurityDeposit || "");
  const [securityReceivedAmount, setSecurityReceivedAmount] = useState("");
  const [securityDepositRemarks, setSecurityDepositRemarks] = useState("");

  const [rentStatus, setRentStatus] = useState("UNPAID");
  const [nextDueDate, setNextDueDate] = useState("");
  const [joinDate, setJoinDate] = useState(() => {
    if (tenant.JoiningDate) {
      const date = new Date(tenant.JoiningDate);
      return date.toISOString().split('T')[0];
    }
    return "";
  });

  const [creatingAgreement, setCreatingAgreement] = useState(false);
  const [agreementSuccess, setAgreementSuccess] = useState("");

  console.log("ReviewModal tenant data:", tenant);

  const roomTypeOptions = [
    { value: "Single", label: "Single" },
    { value: "Double", label: "Double" },
    { value: "Triple", label: "Triple" },
    { value: "Quad", label: "Quad" },
    { value: "Dorm", label: "Dorm" }
  ];

  // Fetch vacant beds when room type changes
  useEffect(() => {
    if (roomType && selectedPGId) {
      fetchVacantBeds();
    } else {
      setVacantBeds([]);
      setBedId("");
    }
  }, [roomType, selectedPGId]);

  const fetchVacantBeds = async () => {
    setLoadingBeds(true);
    setError("");
    try {
      const response = await getVacantBeds(selectedPGId, roomType);
      if (response && response.length > 0) {
        setVacantBeds(response);
      } else {
        setVacantBeds([]);
        setError("No vacant beds available for this room type");
      }
    } catch (err) {
      console.error("Error fetching vacant beds:", err);
      setError("Failed to load vacant beds");
    } finally {
      setLoadingBeds(false);
    }
  };

  // Function to calculate rent
  const handleCalculateRent = async () => {
    // Validate required fields
    if (!joinDate) {
      setError("Please select Joining Date");
      return;
    }
    if (!nextDueDate) {
      setError("Please select Last Bill Date");
      return;
    }
    if (!rentAmount || rentAmount <= 0) {
      setError("Please enter a valid Rent Amount");
      return;
    }

    setCalculatingRent(true);
    setError("");

    try {
      const response = await getRentCalculate(
        tenant.TenantID,
        joinDate,
        nextDueDate,
        parseFloat(rentAmount)
      );

      console.log("Rent calculation response:", response);

      if (response && response[0] && response[0].RentCalculate !== undefined) {
        setCalculatedRent(response[0].RentCalculate);
      } else {
        setError("Failed to calculate rent");
        setCalculatedRent(null);
      }
    } catch (err) {
      console.error("Error calculating rent:", err);
      setError("Failed to calculate rent. Please try again.");
      setCalculatedRent(null);
    } finally {
      setCalculatingRent(false);
    }
  };



  // New function to create agreement
  const handleCreateAgreement = async () => {
    // Validate required fields
    if (!roomType) {
      setError("Please select a room type");
      return;
    }
    if (!bedId) {
      setError("Please select a bed");
      return;
    }
    if (!rentAmount || rentAmount <= 0) {
      setError("Please enter a valid rent amount");
      return;
    }
    if (!nextDueDate) {
      setError("Please select last bill date");
      return;
    }
    if (!joinDate) {
      setError("Please select joining date");
      return;
    }

    if (securityDepositAmount && parseFloat(securityDepositAmount) <= 0) {
      setError("Please enter a valid security deposit amount");
      return;
    }

    if (securityReceivedAmount && parseFloat(securityReceivedAmount) < 0) {
      setError("Please enter a valid received amount");
      return;
    }

    setCreatingAgreement(true);
    setError("");
    setAgreementSuccess("");

    try {

      const agreementData = {
        PGID: selectedPGId,
        TenantID: tenant.TenantID,
        RentType: rentType || "MONTHLY",
        RentAmount: parseFloat(rentAmount),
        BedID: parseInt(bedId),
        SecurityDeposit: securityDepositAmount ? parseFloat(securityDepositAmount) : 0,
        DepositAmount: deposit ? parseFloat(deposit) : 0,
        JoinDate: joinDate,
        CreatedBy: parseInt(localStorage.getItem("userId")) || 1
      };

      console.log("Creating agreement with data:", agreementData);

      const response = await createRentAgreement(agreementData);

      console.log("Agreement creation response:", response);

      if (response.success) {
        alert("Agreement created successfully!")
        setAgreementSuccess("Agreement created successfully!");

        // 🔥 NEW: Call onAgreementCreated callback to refresh tenant list
        if (onAgreementCreated) {
          await onAgreementCreated(selectedPGId);
        }

        // Close modal after 2 seconds
        setTimeout(() => {
          onClose();
        }, 2000);
      } else {
        setError(response.message || "Failed to create agreement");
      }
    } catch (err) {
      console.error("Error creating agreement:", err);
      setError(err.message || "An error occurred while creating agreement");
    } finally {
      setCreatingAgreement(false);
    }
  };


  const Row = ({ label, value }) => (
    <div className="rv-row">
      <span className="rv-row-label">{label}</span>
      <span className="rv-row-value">{value || "—"}</span>
    </div>
  );

  const DocLink = ({ file, label }) => (
    <div className="rv-doc">
      {file ? (
        <>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#16A34A" strokeWidth="2.5" strokeLinecap="round">
            <path d="M20 6L9 17l-5-5" />
          </svg>
          <span className="rv-doc-name">{file}</span>
        </>
      ) : (
        <>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2.5" strokeLinecap="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
          <span className="rv-doc-missing">Not uploaded</span>
        </>
      )}
      <span className="rv-doc-label">{label}</span>
    </div>
  );

  const handleVerify = () => {
    if (!roomType) {
      setError("Please select a room type");
      return;
    }
    if (!bedId) {
      setError("Please select a bed");
      return;
    }
    if (!rentAmount || rentAmount <= 0) {
      setError("Please enter a valid rent amount");
      return;
    }

    if (!nextDueDate) {
      setError("Please select last bill date");
      return;
    }

    if (!joinDate) {
      setError("Please select joining date");
      return;
    }

    if (calculatedRent === null) {
      setError("Please calculate rent first");
      return;
    }

    // Validate security deposit fields
    if (securityDepositAmount && parseFloat(securityDepositAmount) <= 0) {
      setError("Please enter a valid security deposit amount");
      return;
    }

    if (securityReceivedAmount && parseFloat(securityReceivedAmount) < 0) {
      setError("Please enter a valid received amount");
      return;
    }

    onVerify({
      TenantId: tenant.TenantID,
      RentType: rentType,
      RentAmount: parseFloat(rentAmount),
      BedID: parseInt(bedId),
      TenantVerified: true,
      RentStatus: rentStatus,
      NextDueDate: nextDueDate,
      JoinDate: joinDate,
      Advance: parseFloat(0),
      Deposit: parseFloat(deposit) || 0,
      PreviousBalance: parseFloat(calculatedRent),
      tenantData: tenant,

      // Security Deposit Data
      SecurityDepositAmount: securityDepositAmount ? parseFloat(securityDepositAmount) : 0,
      SecurityReceivedAmount: securityReceivedAmount ? parseFloat(securityReceivedAmount) : 0,

    });
  };

  return (
    <div className="rv-overlay" >
      <div className="rv-modal" onClick={(e) => e.stopPropagation()}>
        <div className="rv-head">
          <div>
            <h2 className="rv-title">{tenant.TenantName}</h2>
            <p className="rv-sub">
              {tenant.PhoneNumber}
              {tenant.BedID ? ` · Bed ID: ${tenant.BedID}` : ""}
            </p>
            <p>
              <span className={`od-vt-status ${tenant.AgreementStatus === "TENANT_ACCEPTED" ? 'status-accepted' :
                tenant.AgreementStatus === "REJECTED" ? 'status-rejected' :
                  tenant.AgreementStatus === "DRAFT" ? 'status-draft' : ''
                }`}>
                Agreement Status: {tenant.AgreementStatus === "TENANT_ACCEPTED" ? "Accepted" :
                  tenant.AgreementStatus === "REJECTED" ? "Rejected" :
                    tenant.AgreementStatus === "DRAFT" ? "Draft" :
                      tenant.AgreementStatus === "Generate" ? "Not Generated" : "N/A"}
              </span>
            </p>
          </div>
          <button className="rv-close" onClick={onClose}>
            <svg width="15" height="15" viewBox="0 0 18 18" fill="none">
              <path d="M1 1L17 17M17 1L1 17" stroke="#374151" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>
        <div className="rv-body">

          {/* Success Message */}
          {agreementSuccess && (
            <div className="od-alert od-alert-success" style={{ marginBottom: '16px', padding: '12px', background: '#DCFCE7', color: '#166534', borderRadius: '8px' }}>
              {agreementSuccess}
            </div>
          )}


          <div className="rv-section">
            <h4 className="rv-section-title">Personal Information</h4>
            <Row label="Full Name" value={tenant.TenantName} />
            <Row label="Age" value={tenant.Tenantage} />
            <Row label="Date of Birth" value={tenant.TenantDOB ? formatDateToDDMMYYYY(tenant.TenantDOB) : ""} />
            <Row label="Gender" value={tenant.Gender} />
            <Row label="Mobile Number" value={tenant.PhoneNumber} />
            <Row label="Email" value={tenant.Email1} />
            <Row label="Present Address" value={tenant.PresentAddress} />
            <Row label="Permanent Address" value={tenant.PermanentAddress} />
          </div>
          <div className="rv-section">
            <h4 className="rv-section-title">Emergency Contact</h4>
            <Row label="Contact Name" value={tenant.EmergencyContactPersonName} />
            <Row label="Contact Number" value={tenant.EmergencyContactNumber} />
            <Row label="Relation" value={tenant.EmergencyContactRelation} />
          </div>
          <div className="rv-section">
            <h4 className="rv-section-title">Professional Details</h4>
            <Row label="Profession" value={tenant.TenantProfession} />
            <Row label="Check-in Date" value={tenant.CheckInDate ? formatDateToDDMMYYYY(tenant.CheckInDate) : ""} />
          </div>
          <div className="rv-section">
            <h4 className="rv-section-title">Uploaded Documents</h4>
            <div className="rv-docs-grid">
              <DocLink file={tenant.TenantAadharCard} label="Aadhaar Card" />
              <DocLink file={tenant.TenantPhoto} label="Passport Photo" />
              <DocLink file={tenant.TenantWorkingID} label="Work / Student ID" />
            </div>
          </div>
          <div className="rv-section rv-section-owner">
            <h4 className="rv-section-title rv-section-title-owner">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
              Owner Details
            </h4>
            <div className="rv-owner-grid">
              {/* <div className="rv-owner-field">
                <label className="rv-owner-label">Rent Type</label>
                <select
                  className="rv-owner-select"
                  value={rentType}
                  onChange={(e) => setRentType(e.target.value)}
                >
                  <option value="">Select type</option>
                  <option value="monthly">Monthly</option>
                  <option value="yearly">Yearly</option>
                </select>
              </div> */}

              <div className="rv-owner-field">
                <label className="rv-owner-label">Room Type</label>
                <select
                  className="rv-owner-select"
                  value={roomType}
                  onChange={(e) => setRoomType(e.target.value)}
                >
                  <option value="">Select room type</option>
                  {roomTypeOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>

              <div className="rv-owner-field">
                <label className="rv-owner-label">Select Bed</label>
                <select
                  className="rv-owner-select"
                  value={bedId}
                  onChange={(e) => setBedId(e.target.value)}
                  disabled={loadingBeds || vacantBeds.length === 0}
                >
                  <option value="">{loadingBeds ? "Loading..." : (vacantBeds.length === 0 ? "No beds available" : "Select bed")}</option>
                  {vacantBeds.map(bed => (
                    <option key={bed.BedID} value={bed.BedID}>
                      {bed.VACANT} - {bed.RoomType}
                    </option>
                  ))}
                </select>
              </div>

              <div className="rv-owner-field">
                <label className="rv-owner-label">Rent Amount (₹)</label>
                <input
                  className="rv-owner-input"
                  type="number"
                  placeholder="e.g. 8000"
                  value={rentAmount}
                  onChange={(e) => setRentAmount(e.target.value)}
                />
              </div>

              {/* Security Deposit Fields */}
              <div className="rv-owner-field">
                <label className="rv-owner-label">Security Deposit Amount (₹)</label>
                <input
                  className="rv-owner-input"
                  type="number"
                  placeholder="e.g. 10000"
                  value={securityDepositAmount}
                  onChange={(e) => setSecurityDepositAmount(e.target.value)}
                />
              </div>

              {/* <div className="rv-owner-field">
                <label className="rv-owner-label">Rent Status</label>
                <select
                  className="rv-owner-select"
                  value={rentStatus}
                  onChange={(e) => setRentStatus(e.target.value)}
                >
                  <option value="PAID">PAID</option>
                  <option value="UNPAID">UNPAID</option>
                </select>
              </div> */}

              <div className="rv-owner-field">
                <label className="rv-owner-label">Joining Date</label>
                <input
                  className="rv-owner-input"
                  type="date"
                  value={joinDate}
                  onChange={(e) => setJoinDate(e.target.value)}
                />
              </div>

              <div className="rv-owner-field">
                <label className="rv-owner-label">Last Bill Date</label>
                <input
                  className="rv-owner-input"
                  type="date"
                  value={nextDueDate}
                  onChange={(e) => setNextDueDate(e.target.value)}
                />
              </div>

              {/* Calculate Rent Button and Display */}
              <div className="rv-owner-field rv-calculate-field">
                <button
                  className="rv-btn-calculate"
                  onClick={handleCalculateRent}
                  disabled={calculatingRent}
                >
                  {calculatingRent ? "Calculating..." : "Calculate Rent"}
                </button>
              </div>

              {calculatedRent !== null ? (
                <div className="rv-owner-field rv-calculated-rent">
                  <label className="rv-owner-label">Rent Calculated:</label>
                  <div className="rv-calculated-value">
                    ₹ {calculatedRent.toLocaleString('en-IN')}
                  </div>
                </div>
              ) :
                (
                  <div className="rv-owner-field rv-calculated-rent">

                  </div>
                )}

              <div className="rv-owner-field">
                <label className="rv-owner-label">Rent Received (₹)</label>
                <input
                  className="rv-owner-input"
                  type="number"
                  placeholder="e.g. 5000"
                  value={deposit}
                  onChange={(e) => setDeposit(e.target.value)}
                />
              </div>

              <div className="rv-owner-field">
                <label className="rv-owner-label">Security Received (₹)</label>
                <input
                  className="rv-owner-input"
                  type="number"
                  placeholder="e.g. 5000"
                  value={securityReceivedAmount}
                  onChange={(e) => setSecurityReceivedAmount(e.target.value)}
                />
              </div>

            </div>
            {error && <p className="rv-error" style={{ color: '#DC2626', fontSize: '12px', marginTop: '8px' }}>{error}</p>}
          </div>
        </div>
        <div className="rv-footer">
          <button className="rv-btn rv-btn-outline" onClick={onClose}>Close</button>

          {/* New Create Agreement Button - Left side */}
          {tenant.AgreementStatus === "Generate" &&
            <button
              className="rv-btn rv-btn-agreement"
              onClick={handleCreateAgreement}
              disabled={creatingAgreement}
              style={{
                background: '#8B5CF6',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '10px',
                fontWeight: '500',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              {creatingAgreement ? (
                <>
                  <span className="od-spinner" style={{ width: '16px', height: '16px', border: '2px solid rgba(255,255,255,0.3)', borderTopColor: 'white', borderRadius: '50%', animation: 'od-spin 0.8s linear infinite' }}></span>
                  Creating...
                </>
              ) : (
                <>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round">
                    <path d="M12 5v14M5 12h14" />
                  </svg>
                  Create Agreement
                </>
              )}
            </button>
          }


          {tenant.AgreementStatus === "TENANT_ACCEPTED" &&
            <button className="rv-btn rv-btn-verify" onClick={handleVerify}>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6L5 9L10 3" stroke="#fff" strokeWidth="2" strokeLinecap="round" /></svg>
              Verify Tenant & Assign Bed
            </button>
          }
        </div>
      </div>
    </div>
  );
};


// ─── Assign Room Modal ────────────────────────────────────────────

const AssignRoomModal = ({ tenant, vacantRooms, onClose, onAssign }) => {
  const [selectedRoom, setSelectedRoom] = useState("");
  return (
    <div className="rv-overlay" >
      <div className="rv-modal rv-modal-sm" onClick={(e) => e.stopPropagation()}>
        <div className="rv-head">
          <div>
            <h2 className="rv-title">Assign Room</h2>
            <p className="rv-sub">Assigning to {tenant.name}</p>
          </div>
          <button className="rv-close" onClick={onClose}>
            <svg width="15" height="15" viewBox="0 0 18 18" fill="none"><path d="M1 1L17 17M17 1L1 17" stroke="#374151" strokeWidth="2" strokeLinecap="round" /></svg>
          </button>
        </div>
        <div className="rv-body">
          <div className="rv-owner-field">
            <label className="rv-owner-label">Select Vacant Room</label>
            <select className="rv-owner-select" value={selectedRoom} onChange={(e) => setSelectedRoom(e.target.value)}>
              <option value="">Choose a room…</option>
              {vacantRooms.map((r) => (<option key={r} value={r}>Room {r}</option>))}
            </select>
          </div>
        </div>
        <div className="rv-footer">
          <button className="rv-btn rv-btn-outline" onClick={onClose}>Cancel</button>
          <button className="rv-btn rv-btn-verify" disabled={!selectedRoom} onClick={() => onAssign(tenant.id, selectedRoom)}>Assign Room {selectedRoom}</button>
        </div>
      </div>
    </div>
  );
};

// ─── Logout Confirmation Modal ────────────────────────────────────────────
const LogoutConfirmationModal = ({ onClose, onConfirm }) => {
  return (
    <div className="logout-overlay" >
      <div className="logout-modal" onClick={(e) => e.stopPropagation()}>
        <div className="logout-modal-header">
          <div className="logout-icon-wrapper">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
            </svg>
          </div>
        </div>
        <div className="logout-modal-body">
          <h3 className="logout-modal-title">Confirm Logout</h3>
          <p className="logout-modal-message">Are you sure you want to log out? You will need to log in again to access your account.</p>
        </div>
        <div className="logout-modal-footer">
          <button className="logout-btn-cancel" onClick={onClose}>Cancel</button>
          <button className="logout-btn-confirm" onClick={onConfirm}>Logout</button>
        </div>
      </div>
    </div>
  );
};

// ─── No PG Warning Modal ────────────────────────────────────────────
const NoPGWarningModal = ({ onClose }) => {
  return (
    <div className="logout-overlay" >
      <div className="logout-modal" onClick={(e) => e.stopPropagation()}>
        <div className="logout-modal-header">
          <div className="no-pg-icon-wrapper">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        </div>
        <div className="logout-modal-body">
          <h3 className="logout-modal-title">No PG Registered</h3>
          <p className="logout-modal-message">You need to register a PG first before adding rooms, beds, or tenants. Please click on "Add PG" to get started.</p>
        </div>
        <div className="logout-modal-footer">
          <button className="logout-btn-confirm" onClick={onClose}>Got it</button>
        </div>
      </div>
    </div>
  );
};



// ─── Owner Dashboard ──────────────────────────────────────────────
const OwnerDashboard = () => {

  // Get user role from localStorage
  const userRole = parseInt(localStorage.getItem('userRole')) || 2;

  // Role checks
  const isStaff = userRole === 4;
  const isSupportingStaff = userRole === 5;
  const isOwner = userRole === 2;


  // Function to filter nav tabs based on role
  const getFilteredNavTabs = (originalTabs) => {
    if (isOwner) return originalTabs;
    if (isStaff) {
      // For Staff: Remove Revenue and Compliance tabs
      return originalTabs.filter(tab => tab.key !== 'revenue');
    }
    if (isSupportingStaff) {
      // For Supporting Staff: Remove Occupancy, Revenue, Compliance tabs
      return originalTabs.filter(tab => tab.key !== 'occupancy' && tab.key !== 'revenue' && tab.key !== 'compliance');
    }
    return originalTabs;
  };

  // Function to filter stats cards based on role
  const getFilteredStats = (originalStats) => {
    if (isOwner) return originalStats;
    if (isStaff) {
      // For Staff: Remove Revenue and Compliance cards
      return originalStats.filter(stat => stat.key !== 'revenue');
    }
    if (isSupportingStaff) {
      // For Supporting Staff: Remove Occupancy, Revenue, Compliance cards
      return originalStats.filter(stat => stat.key !== 'occupancy' && stat.key !== 'revenue' && stat.key !== 'compliance');
    }
    return originalStats;
  };


  // ─── Constants ────────────────────────────────────────────────────
  const VACANT_ROOMS = ["102", "104", "106", "202", "302", "303"];

  // Quick actions - but we'll filter them dynamically
  const ALL_QUICK_ACTIONS = [
    {
      key: "add_pg",
      label: "Add PG",
      icon: (
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="1.6" strokeLinecap="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
          <polyline points="9 22 9 12 15 12 15 22" />
        </svg>
      ),
    },
    {
      key: "add_room",
      label: "Add Room",
      icon: (
        <svg width="26" height="26" viewBox="0 0 461 478" fill="none" stroke="#F06E18" xmlns="http://www.w3.org/2000/svg">
          <line x1="4.13378" y1="362.655" x2="226.134" y2="280.655" stroke-width="20" />
          <line x1="226.041" y1="455.691" x2="450.041" y2="362.691" stroke-width="20" />
          <line x1="1.11527" y1="86.6618" x2="223.115" y2="2.66178" stroke-width="20" />
          <line x1="2.5" y1="84" x2="2.5" y2="365" stroke-width="20" />
          <line x1="224.5" x2="224.5" y2="283" stroke-width="20" />
          <line x1="448.5" y1="83" x2="448.5" y2="365" stroke-width="20" />
          <line x1="0.954972" y1="362.69" x2="225.955" y2="455.69" stroke-width="20" />
          <line x1="223.863" y1="280.654" x2="446.863" y2="362.654" stroke-width="20" />
          <line x1="225.869" y1="2.65575" x2="449.869" y2="85.6558" stroke-width="20" />
          <line x1="283.5" y1="120" x2="283.5" y2="303" stroke-width="20" />
          <line x1="376.5" y1="153" x2="376.5" y2="336" stroke-width="20" />
          <line x1="284.836" y1="122.644" x2="377.836" y2="155.644" stroke-width="20" />
          <line x1="72.5" y1="157" x2="72.5" y2="256" stroke-width="20" />
          <line x1="161.5" y1="122" x2="161.5" y2="220" stroke-width="20" />
          <line x1="73.0626" y1="253.682" x2="162.063" y2="217.682" stroke-width="20" />
          <line x1="71.1078" y1="158.665" x2="160.108" y2="124.665" stroke-width="20" />
        </svg>

      ),
    },
    {
      key: "add_bed",
      label: "Add Bed",
      icon: (
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="1.6" strokeLinecap="round">
          <path class="cls-1" d="M1.5,9.14H19.64A2.86,2.86,0,0,1,22.5,12v1.91a0,0,0,0,1,0,0H1.5a0,0,0,0,1,0,0V9.14A0,0,0,0,1,1.5,9.14Z" />
          <rect class="cls-1" x="1.5" y="13.91" width="21" height="3.82" />
          <line class="cls-1" x1="1.5" y1="21.55" x2="1.5" y2="2.45" />
          <line class="cls-1" x1="22.5" y1="21.55" x2="22.5" y2="17.73" />
          <path class="cls-1" d="M3.56,5.32H6.12A2.06,2.06,0,0,1,8.18,7.38v0A1.76,1.76,0,0,1,6.43,9.14H3.26A1.76,1.76,0,0,1,1.5,7.38v0A2.06,2.06,0,0,1,3.56,5.32Z" />
          <line class="cls-1" x1="12" y1="9.14" x2="12" y2="13.91" />
        </svg>
      ),
    },
    {
      key: "add_tenant",
      label: "Add Tenant",
      icon: (
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="1.6" strokeLinecap="round">
          <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <line x1="19" y1="8" x2="19" y2="14" />
          <line x1="22" y1="11" x2="16" y2="11" />
        </svg>
      ),
    },
    {
      key: "add_electricity",
      label: "Add Electricity",
      icon: (
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="1.6">
          <path d="M12 2L12 7M12 17L12 22M5 12L2 12M22 12L19 12M6.5 6.5L4.5 4.5M17.5 17.5L19.5 19.5M17.5 6.5L19.5 4.5M6.5 17.5L4.5 19.5M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#F06E18" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
      ),
    },
    {
      key: "add_pg_photos",
      label: "Add PG Photos",
      icon: (
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="1.6" strokeLinecap="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <circle cx="8.5" cy="8.5" r="1.5" fill="#F06E18" />
          <polyline points="21 15 16 10 5 21" />
        </svg>
      ),
    },
    {
      key: "pg_layout",
      label: "PG Layout",
      icon: (
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="1.6" strokeLinecap="round">
          <rect x="3" y="3" width="7" height="7" rx="1" />
          <rect x="14" y="3" width="7" height="7" rx="1" />
          <rect x="3" y="14" width="7" height="7" rx="1" />
          <rect x="14" y="14" width="7" height="7" rx="1" />
        </svg>
      ),
    },
    {
      key: "add_food_menu",
      label: "Food Menu",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="30"
          height="30"
          fill="none"
          stroke="#F06E18"
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M7 2v5H6V2H5v5H4V2H3v5c0 1.93 1.28 3.55 3 4.07V22h1v-10.93c1.72-.52 3-2.14 3-4.07V2H9v5H8V2H7z" />
          <path d="M17 2c-1.38 0-2.5 1.12-2.5 2.5v7.5c0 .55.45 1 1 1h1.5V22h1V2s-1-.03-1 0z" />
        </svg>
      ),
    },
    {
      key: "add_expense",
      label: "Add Expense",
      icon: (
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#F06E18" strokeWidth="1.6" strokeLinecap="round">
          <path d="M6 2h12a1 1 0 011 1v18l-2.5-1.5L14 21l-2.5-1.5L9 21l-2.5-1.5L4 21V3a1 1 0 011-1z" />
          <line x1="8" y1="7" x2="16" y2="7" />
          <line x1="8" y1="11" x2="16" y2="11" />
          <line x1="8" y1="15" x2="12" y2="15" />
        </svg>
      ),
    },
  ];

  // Only show Dashboard tab when no PG is registered
  const getNavTabs = (hasPG) => {
    if (!hasPG) {
      return [{ key: "dashboard", label: "Dashboard" }];
    }
    return [
      { key: "dashboard", label: "Dashboard" },
      // { key: "planning", label: "Planning" },
      { key: "occupancy", label: "Occupancy" },
      { key: "revenue", label: "Revenue" },
      { key: "complaints", label: "Complaints" },
      { key: "compliance", label: "Compliance" },
      { key: "reports", label: "Reports" }
    ];
  };

  // Get quick actions based on whether PG exists
  const getQuickActions = (hasPG) => {
    if (!hasPG) {
      // Only show Add PG button when no PG exists
      return ALL_QUICK_ACTIONS.filter(action => action.key === "add_pg");
    }
    // Show all actions when PG exists
    return ALL_QUICK_ACTIONS;
  };


  const { user, logout } = useAuth();
  console.log(" User info from useAuth:", user);
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("dashboard");
  const [pgList, setPgList] = useState([]);
  const [selectedPG, setSelectedPG] = useState(null);
  const [pgMenuOpen, setPgMenuOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [addTenantRoom, setAddTenantRoom] = useState(null);
  const [pendingTenants, setPendingTenants] = useState([]);
  const [verifiedTenants, setVerifiedTenants] = useState([]);
  const [reviewTenant, setReviewTenant] = useState(null);
  const [assignTenant, setAssignTenant] = useState(null);
  const [addPGModalOpen, setAddPGModalOpen] = useState(false);
  const [addRoomModalOpen, setAddRoomModalOpen] = useState(false);
  const [addBedModalOpen, setAddBedModalOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false); // State for logout modal
  const [isLayoutModalOpen, setIsLayoutModalOpen] = useState(false);
  // const [agreementTenant, setAgreementTenant] = useState(null);

  // Add state:
  const [addElectricityModalOpen, setAddElectricityModalOpen] = useState(false);
  const [roomsList, setRoomsList] = useState([]);

  const [addPGPhotosModalOpen, setAddPGPhotosModalOpen] = useState(false);
  const [foodMenuModalOpen, setFoodMenuModalOpen] = useState(false);
  const [addExpenseModalOpen, setAddExpenseModalOpen] = useState(false);

  // Dashboard data from API
  const [dashboardData, setDashboardData] = useState(null);
  const [loadingDashboard, setLoadingDashboard] = useState(false);
  const [dashboardError, setDashboardError] = useState(null);

  const [loadingTenants, setLoadingTenants] = useState(false);
  const [tenantsError, setTenantsError] = useState(null);

  const [showNoPGWarning, setShowNoPGWarning] = useState(false);

  // Add function to fetch rooms (you'll need to create this API)
  const fetchRooms = async (pgId) => {
    try {
      const response = await roommaster_SelectByPGID(pgId);
      setRoomsList(response || []);
    } catch (error) {
      console.error('Error fetching rooms:', error);
    }
  };

  // Call fetchRooms when selectedPG changes
  useEffect(() => {
    if (selectedPG && selectedPG.PGID) {
      fetchRooms(selectedPG.PGID);
    }
  }, [selectedPG]);



  // Fetch PG list on mount
  useEffect(() => {
    fetchPGList();
  }, []);

  // Fetch dashboard data when selectedPG changes
  useEffect(() => {
    if (selectedPG && selectedPG.PGID) {
      fetchDashboardData(selectedPG.PGID);
    }
  }, [selectedPG]);

  useEffect(() => {
    if (selectedPG && selectedPG.PGID) {
      fetchNewTenants(selectedPG.PGID);
    }
  }, [selectedPG]);

  const fetchNewTenants = async (pgId) => {
    setLoadingTenants(true);
    setTenantsError(null);
    try {
      const response = await getNewTenantList(pgId);
      if (response && response.length > 0) {
        setPendingTenants(response);
      } else {
        setPendingTenants([]);
      }
    } catch (err) {
      console.error("Error fetching new tenants:", err);
      setTenantsError("Failed to load new tenants");
      setPendingTenants([]);
    } finally {
      setLoadingTenants(false);
    }
  };

  useEffect(() => {
    // Check if we have PG data in localStorage
    const storedPgList = localStorage.getItem('userDataList')
    const storedLoginResponse = localStorage.getItem('loginResponse')

    if (storedLoginResponse) {
      try {
        const loginData = JSON.parse(storedLoginResponse)
        const loginInfo = loginData[0]?.[0] || {}
        console.log('User info from localStorage:', loginInfo)
      } catch (error) {
        console.error('Error parsing stored login response:', error)
      }
    }

    // Fetch PG list
    fetchPGList()
  }, [])

  const fetchPGList = async () => {
    try {
      // First, try to get PG list from localStorage
      const storedPgList = localStorage.getItem('userDataList')
      console.log('PG list from localStorage:', storedPgList);

      if (storedPgList) {
        const pgListData = JSON.parse(storedPgList)

        // Transform the data to match the expected format
        const transformedPgList = pgListData.map(pg => ({
          PGID: pg.PGID,
          PGName: pg.PGName,
          PGCode: pg.PGCode,
          PGRent: pg.PGRent,
          PGType: pg.PGType,
          PGStatus: pg.PGStatus,
          PGOwnerName: pg.PGOwnerName,
          PGPhoneNumber: pg.PGPhoneNumber,
          PGAddress: pg.PGAddress,
          PGLocality: pg.PGLocality,
          PGCity: pg.PGCity,
          PGPhoto: pg.PGPhoto,
          AboutProperty: pg.AboutProperty,
          nUserId: pg.nUserId,
          ...pg
        }))

        setPgList(transformedPgList)

        if (transformedPgList.length > 0) {
          setSelectedPG(transformedPgList[0])
        } else {
          setPgList([])
          setSelectedPG(null)
        }
        return
      }
    } catch (err) {
      console.error('Error fetching PG list:', err)
      const storedPgList = localStorage.getItem('userDataList')
      if (storedPgList) {
        const pgListData = JSON.parse(storedPgList)
        const transformedPgList = pgListData.map(pg => ({
          PGID: pg.PGID,
          PGName: pg.PGName,
          ...pg
        }))
        setPgList(transformedPgList)
        if (transformedPgList.length > 0) {
          setSelectedPG(transformedPgList[0])
        }
      } else {
        setPgList([])
        setSelectedPG(null)
      }
    }
  }

  const fetchDashboardData = async (pgid) => {
    try {
      setLoadingDashboard(true);
      setDashboardError(null);

      const response = await get_owner_dashboard(pgid);

      if (response && response.length > 0) {
        setDashboardData(response[0]);
      } else if (response) {
        setDashboardData(response);
      } else {
        setDashboardData(null);
      }
    } catch (err) {
      setDashboardError(err.message || 'Failed to fetch dashboard data');
      console.error('Error fetching dashboard data:', err);
    } finally {
      setLoadingDashboard(false);
    }
  };

  // Updated logout handler with confirmation
  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleConfirmLogout = () => {
    // Clear localStorage on logout
    localStorage.removeItem('loginResponse')
    localStorage.removeItem('userDataList')
    localStorage.clear()
    logout()
    navigate('/')
  };

  const handleCancelLogout = () => {
    setShowLogoutModal(false);
  };

  const openAddTenant = (room = null) => setAddTenantRoom(room || "open");

  const handleTenantSubmit = (data) => setPendingTenants((p) => [data, ...p]);

  const handleVerify = async (updatedTenant) => {
    try {
      const response = await updateRentAndBed({
        TenantId: updatedTenant.TenantId,
        // RentType: updatedTenant.RentType,
        RentType: 'monthly',
        RentAmount: updatedTenant.RentAmount,
        BedID: updatedTenant.BedID,
        TenantVerified: updatedTenant.TenantVerified,
        // RentStatus: updatedTenant.RentStatus,
        RentStatus: null,
        NextDueDate: updatedTenant.NextDueDate,
        JoinDate: updatedTenant.JoinDate,

        Advance: updatedTenant.Advance || 0,
        Deposit: updatedTenant.Deposit || 0,
        PreviousBalance: updatedTenant.PreviousBalance || 0,

        SecurityDepositAmount: updatedTenant.SecurityDepositAmount || 0,
        SecurityReceivedAmount: updatedTenant.SecurityReceivedAmount || 0,
      });
      console.log("response from updateRentAndBed API:", response);

      if (response.Success || response.AdmissionID) {
        const admissionId = response.AdmissionID;
        // Create tenant user account
        try {
          const tenantData = updatedTenant.tenantData;
          const userData = {
            FullName: tenantData.TenantName.trim(),
            UserName: tenantData.PhoneNumber.trim(), // Using phone number as username
            Password: tenantData.PhoneNumber.trim(),
            MobileNo: tenantData.PhoneNumber.trim(),
            EmailId: tenantData.Email1?.trim() || "",
            RoleId: 3, // RoleId 3 for tenant
            PGID: selectedPG?.PGID // Current selected PG ID
          };

          console.log("Creating tenant user with data:", userData);

          const createUserResponse = await CreateUser(userData);
          console.log("Create user response:", createUserResponse);

          if (createUserResponse) {
            alert("Tenant verified and bed assigned.");
          }

        } catch (userErr) {
          console.error("Error assigning bed to tenant. Please try again:", userErr);
          alert("Error assigning bed to tenant. Please try again.");
        }

        setPendingTenants((p) => p.filter((t) => t.TenantID !== updatedTenant.TenantId));
        setVerifiedTenants((p) => [updatedTenant.tenantData, ...p]);
        setReviewTenant(null);
        // alert("Tenant verified and bed assigned successfully!");
      } else {
        alert(response.Message || "Failed to verify tenant");
      }
    } catch (err) {
      console.error("Error verifying tenant:", err);
      alert("Failed to verify tenant. Please try again.");
    }
  };

  const handleAssign = (tenantId) => {
    setVerifiedTenants((p) => p.filter((t) => t.id !== tenantId));
    setAssignTenant(null);
  };

  const handleAddPG = (pgData) => {
    console.log("New PG added:", pgData);
    fetchPGList();
  };


  // Get dynamic NAV_TABS based on whether PG exists
  // const NAV_TABS = getNavTabs(pgList.length > 0);

  const NAV_TABS = getFilteredNavTabs([
    { key: "dashboard", label: "Dashboard" },
    // { key: "planning", label: "Planning" },
    { key: "occupancy", label: "Occupancy" },
    { key: "revenue", label: "Revenue" },
    { key: "complaints", label: "Complaints" },
    { key: "compliance", label: "Compliance" },
    { key: "reports", label: "Reports" }
  ]);

  // Get dynamic QUICK_ACTIONS based on whether PG exists
  const QUICK_ACTIONS = getQuickActions(pgList.length > 0);



  // Generate dynamic stats based on dashboard data
  const getStats = () => {
    if (!dashboardData) return [];

    return [
      {
        key: "occupancy",
        label: "Occupancy",
        value: `${Math.round(dashboardData.OccupancyPercentage ?? dashboardData.occupancyPercentage ?? 0)}%`,
        bar: dashboardData.OccupancyPercentage || dashboardData.occupancyPercentage || 0,
        color: "#22C55E",
        icon: (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
          </svg>
        ),
        iconBg: "#DCFCE7",
        iconColor: "#16A34A",
        trend: dashboardData.OccupancyTrend || dashboardData.occupancyTrend || '+5% this month',
        trendUp: (dashboardData.OccupancyPercentage || dashboardData.occupancyPercentage || 0) > 50,
      },
      {
        key: "revenue",
        label: "Revenue",
        value: `₹${(dashboardData.MonthlyIncome || dashboardData.monthlyIncome || 0).toLocaleString('en-IN')}`,
        bar: Math.min(((dashboardData.MonthlyIncome || dashboardData.monthlyIncome || 0) / ((dashboardData.MonthlyExpense || dashboardData.monthlyExpense || 1))) * 100, 100),
        color: "#6366F1",
        icon: (
          //           <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          //   <path d="M12.9494914,6 C13.4853936,6.52514205 13.8531598,7.2212202 13.9645556,8 L17.5,8 C17.7761424,8 18,8.22385763 18,8.5 C18,8.77614237 17.7761424,9 17.5,9 L13.9645556,9 C13.7219407,10.6961471 12.263236,12 10.5,12 L7.70710678,12 L13.8535534,18.1464466 C14.0488155,18.3417088 14.0488155,18.6582912 13.8535534,18.8535534 C13.6582912,19.0488155 13.3417088,19.0488155 13.1464466,18.8535534 L6.14644661,11.8535534 C5.83146418,11.538571 6.05454757,11 6.5,11 L10.5,11 C11.709479,11 12.7183558,10.1411202 12.9499909,9 L6.5,9 C6.22385763,9 6,8.77614237 6,8.5 C6,8.22385763 6.22385763,8 6.5,8 L12.9499909,8 C12.7183558,6.85887984 11.709479,6 10.5,6 L6.5,6 C6.22385763,6 6,5.77614237 6,5.5 C6,5.22385763 6.22385763,5 6.5,5 L10.5,5 L17.5,5 C17.7761424,5 18,5.22385763 18,5.5 C18,5.77614237 17.7761424,6 17.5,6 L12.9494914,6 L12.9494914,6 Z" />
          // </svg>

          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M7 5H12C14.2091 5 16 6.79086 16 9V9C16 11.2091 14.2091 13 12 13H9L15 19" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M6 5L18 5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8 9L18 9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        ),
        iconBg: "#EEF2FF",
        iconColor: "#6366F1",
        trend: dashboardData.RevenueTrend || dashboardData.revenueTrend || '+₹12,000 vs last month',
        trendUp: (dashboardData.MonthlyIncome || dashboardData.monthlyIncome || 0) > (dashboardData.MonthlyExpense || dashboardData.monthlyExpense || 0),
      },
      {
        key: "complaints",
        label: "Complaints",
        value: `${dashboardData.OpenComplaint || dashboardData.openComplaint || 0}`,
        bar: Math.min(((dashboardData.OpenComplaint || dashboardData.openComplaint || 0) / 10) * 100, 100),
        color: "#F59E0B",
        icon: (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
          </svg>
        ),
        iconBg: "#FEF3C7",
        iconColor: "#D97706",
        trend: dashboardData.ComplaintTrend || dashboardData.complaintTrend || '2 resolved this week',
        trendUp: false,
      },
      {
        key: "compliance",
        label: "Compliance",
        value: `${Math.round(dashboardData.Compliance ?? dashboardData.compliance ?? 0)}%`,
        bar: dashboardData.Compliance || dashboardData.compliance || 0,
        color: "#6366F1",
        icon: (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
        ),
        iconBg: "#EEF2FF",
        iconColor: "#6366F1",
        trend: dashboardData.ComplianceTrend || dashboardData.complianceTrend || (dashboardData.Compliance || dashboardData.compliance || 0) >= 70 ? 'Good compliance' : 'Needs attention',
        trendUp: (dashboardData.Compliance || dashboardData.compliance || 0) >= 70,
      },
    ];
  };


  const originalStats = getStats();
  const STATS = getFilteredStats(originalStats);




  //   const handleAgreementClick = (tenant) => {
  //     setAgreementTenant(tenant);
  //   };

  //  const handleAgreementCreate = (data) => {
  //     console.log('Agreement created:', data);
  //     // You can add additional logic here like refreshing the list
  //     // Show success toast notification
  //     alert('Agreement created successfully!');
  //     setAgreementTenant(null)
  //   };



  return (
    <div className="od-root">
      <style>{`
        /* Loading State */
        .od-loading-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 60px 20px;
          text-align: center;
        }

        .od-spinner {
          width: 40px;
          height: 40px;
          border: 3px solid #E5E7EB;
          border-top-color: #6366F1;
          border-radius: 50%;
          animation: od-spin 0.8s linear infinite;
          margin-bottom: 16px;
        }

        @keyframes od-spin {
          to {
            transform: rotate(360deg);
          }
        }

        .od-loading-state p {
          color: #6B7280;
          font-size: 14px;
        }

        /* Error State */
        .od-error-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 60px 20px;
          text-align: center;
          background: #FEF2F2;
          border-radius: 12px;
          margin: 20px 0;
        }

        .od-error-state p {
          color: #DC2626;
          font-size: 14px;
          margin-bottom: 16px;
        }

        .od-retry-btn {
          padding: 8px 20px;
          background: #DC2626;
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s;
        }

        .od-retry-btn:hover {
          background: #B91C1C;
        }

        /* Enhanced PG Selector Styles */
        .od-pg-selector {
          position: relative;
        }

        .od-pg-trigger {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 10px 16px;
          background: white;
          border: 1px solid #E5E7EB;
          border-radius: 12px;
          font-size: 14px;
          font-weight: 500;
          color: #1F2937;
          cursor: pointer;
          transition: all 0.2s;
        }

        .od-pg-trigger:hover {
        color: #F06E18;
          background: #F9FAFB;
          border-color: #F06E18;
          svg {
        color: #F06E18;
        }
        }
          


        .od-pg-chevron {
          margin-left: 4px;
          transition: transform 0.2s;
        }

        .od-pg-selector.open .od-pg-chevron {
          transform: rotate(180deg);
        }

        .od-pg-menu {
          position: absolute;
          top: calc(100% + 8px);
          right: 0;
          min-width: 240px;
          background: white;
          border-radius: 12px;
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.02);
          border: 1px solid #E5E7EB;
          overflow: hidden;
          z-index: 50;
          animation: od-slideDown 0.2s ease-out;
        }

        @keyframes od-slideDown {
          from {
            opacity: 0;
            transform: translateY(-8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .od-pg-item {
          display: flex;
          align-items: center;
          gap: 12px;
          width: 100%;
          padding: 12px 16px;
          background: white;
          border: none;
          text-align: left;
          cursor: pointer;
          transition: background 0.2s;
          border-bottom: 1px solid #F3F4F6;
          font-size: 14px;
          font-weight: 500;
          color: #1F2937;
        }

        .od-pg-item:last-child {
          border-bottom: none;
        }

        .od-pg-item:hover {
          background: #F9FAFB;
        }

        .od-pg-item.selected {
          background: #EEF2FF;
          color: #F06E18;
          .svg-sel{
    color: #F06E18
  }
        }

        /* Logout Modal Styles */
        .logout-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          animation: fadeIn 0.2s ease-out;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        .logout-modal {
          background: white;
          border-radius: 20px;
          width: 90%;
          max-width: 400px;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          animation: slideUp 0.3s ease-out;
        }

        @keyframes slideUp {
          from {
            transform: translateY(20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        .logout-modal-header {
          padding: 24px 24px 0 24px;
          text-align: center;
        }

        .logout-icon-wrapper {
          width: 64px;
          height: 64px;
          background: #FEF2F2;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          color: #DC2626;
        }

        .logout-modal-body {
          padding: 20px 24px;
          text-align: center;
        }

        .logout-modal-title {
          font-size: 20px;
          font-weight: 600;
          color: #1F2937;
          margin-bottom: 8px;
        }

        .logout-modal-message {
          font-size: 14px;
          color: #6B7280;
          line-height: 1.5;
        }

        .logout-modal-footer {
          padding: 16px 24px 24px 24px;
          display: flex;
          gap: 12px;
        }

        .logout-btn-cancel,
        .logout-btn-confirm {
          flex: 1;
          padding: 10px 16px;
          border-radius: 10px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          border: none;
        }

        .logout-btn-cancel {
          background: #F3F4F6;
          color: #4B5563;
        }

        .logout-btn-cancel:hover {
          background: #E5E7EB;
        }

        .logout-btn-confirm {
          background: #DC2626;
          color: white;
        }

        .logout-btn-confirm:hover {
          background: #B91C1C;
        }

        /* Responsive Styles */
        @media (max-width: 768px) {
          .od-pg-menu {
            position: fixed;
            top: auto;
            bottom: 0;
            left: 0;
            right: 0;
            min-width: auto;
            border-radius: 20px 20px 0 0;
            max-height: 70vh;
            overflow-y: auto;
            animation: od-slideUp 0.3s ease-out;
          }
          
          @keyframes od-slideUp {
            from {
              transform: translateY(100%);
            }
            to {
              transform: translateY(0);
            }
          }
          
          .od-pg-item {
            padding: 16px;
          }
          
          .od-page-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
          }
          
          .od-pg-selector {
            width: 100%;
          }
          
          .od-pg-trigger {
            width: 100%;
            justify-content: space-between;
          }
        }

        .no-pg-icon-wrapper {
          width: 64px;
          height: 64px;
          background: #FEF3C7;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          color: #D97706;
        }
      `}</style>

      {/* ── Modals ── */}

      <AddTenantModal isOpen={!!addTenantRoom} room={addTenantRoom !== "open" ? addTenantRoom : null} onClose={() => setAddTenantRoom(null)} onSubmit={handleTenantSubmit} selectedPG={selectedPG}
        onSuccess={() => fetchNewTenants(selectedPG?.PGID)} />
      {addPGModalOpen && <AddPGModal isOpen={addPGModalOpen} onClose={() => setAddPGModalOpen(false)} onSubmit={handleAddPG} />}
      {addRoomModalOpen && <AddRoomModal isOpen={addRoomModalOpen} onClose={() => setAddRoomModalOpen(false)} selectedPG={selectedPG} onRoomAdded={(roomData) => {
        console.log("Room added:", roomData);
      }} />}
      {addBedModalOpen && <AddBedModal isOpen={addBedModalOpen} onClose={() => setAddBedModalOpen(false)} selectedPG={selectedPG} onBedAdded={(bedData) => {
        console.log("Bed added:", bedData);
      }} />}
      {reviewTenant && (
        <ReviewModal
          tenant={reviewTenant}
          selectedPGId={selectedPG?.PGID}
          onClose={() => setReviewTenant(null)}
          onVerify={handleVerify}
          onAgreementCreated={fetchNewTenants}
        />
      )}


      {/* Agreement Modal */}
      {/* {agreementTenant && (
        <AgreementModal
          tenant={agreementTenant}
          selectedPGId={selectedPG?.PGID}
          onClose={() => setAgreementTenant(null)}
          onCreate={handleAgreementCreate}
        />
      )} */}


      {assignTenant && <AssignRoomModal tenant={assignTenant} vacantRooms={VACANT_ROOMS} onClose={() => setAssignTenant(null)} onAssign={handleAssign} />}

      {addElectricityModalOpen && (
        <AddElectricityReadingModal
          isOpen={addElectricityModalOpen}
          onClose={() => setAddElectricityModalOpen(false)}
          selectedPG={selectedPG}
          rooms={roomsList}
          onReadingAdded={(readingData) => {
            console.log("Electricity reading added:", readingData);
            // You can refresh data here if needed
          }}
        />
      )}

      {addPGPhotosModalOpen && (
        <AddPGPhotosModal
          isOpen={addPGPhotosModalOpen}
          onClose={() => setAddPGPhotosModalOpen(false)}
          selectedPG={selectedPG}
          onSuccess={() => {
            console.log('Photos updated successfully');
          }}
        />
      )}

      {isLayoutModalOpen && (
        <PGLayoutModal
          isOpen={isLayoutModalOpen}
          onClose={() => setIsLayoutModalOpen(false)}
          selectedPG={selectedPG}
        />
      )}

      {foodMenuModalOpen && (
        <FoodMenuModal
          isOpen={foodMenuModalOpen}
          onClose={() => setFoodMenuModalOpen(false)}
          selectedPG={selectedPG}
          onSubmit={async (menuData) => {
            console.log("Food menu added:", menuData);
            // TODO: wire to real API once the food-menu endpoint is available
          }}
        />
      )}

      {addExpenseModalOpen && (
        <AddExpenseModal
          isOpen={addExpenseModalOpen}
          onClose={() => setAddExpenseModalOpen(false)}
          selectedPG={selectedPG}
          // tenants={verifiedTenants}
          // onSubmit={async (expenseData) => {
          //   console.log("Expense added:", expenseData);
          //   // TODO: wire to real API once the expense endpoint is available
          // }}
          onSuccess={(response) => {
            console.log("Expense saved successfully:", response);
            // Optionally refresh expense list or update stats
            // You can add additional logic here
          }}
        />
      )}

      {/* Logout Confirmation Modal */}
      {showLogoutModal && (
        <LogoutConfirmationModal
          onClose={handleCancelLogout}
          onConfirm={handleConfirmLogout}
        />
      )}

      {showNoPGWarning && (
        <NoPGWarningModal onClose={() => setShowNoPGWarning(false)} />
      )}


      {drawerOpen && <div className="od-drawer-overlay" onClick={() => setDrawerOpen(false)} />}

      <aside className={`od-drawer ${drawerOpen ? "open" : ""}`}>
        <div className="od-drawer-header">
          <img src="/assets/kys-logo.png" alt="KYS PG" className="od-drawer-logo" />
          <button className="od-drawer-close" onClick={() => setDrawerOpen(false)}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M1 1L17 17M17 1L1 17" stroke="#374151" strokeWidth="2" strokeLinecap="round" /></svg>
          </button>
        </div>
        <nav className="od-drawer-nav">
          {NAV_TABS.map((tab) => (
            <button key={tab.key} className={`od-drawer-item ${activeTab === tab.key ? "active" : ""}`} onClick={() => { setActiveTab(tab.key); setDrawerOpen(false); }}>
              {tab.label}
            </button>
          ))}
        </nav>
        <div className="od-drawer-footer">
          <span className="od-drawer-user">{user?.name || "Owner"}</span>
          <button className="od-drawer-logout" onClick={handleLogoutClick}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
            </svg>
            Logout
          </button>
        </div>
      </aside>

      <header className="od-navbar">
        <div className="od-navbar-inner">
          <button className="od-brand" onClick={() => {
            console.log("localStorage.getItem('userRole'):", localStorage.getItem('userRole'));

            // localStorage.getItem('userRole') == 2 ? navigate("/owner-dashboard") : navigate("/tenant-dashboard")
            navigate("/")
          }
          }>
            <img src="/assets/AapkaPG-logo.svg" alt="KYS PG" className="od-navbar-logo" />
          </button>
          <nav className="od-nav-tabs">
            {NAV_TABS.map((tab) => (
              <button key={tab.key} className={`od-nav-tab ${activeTab === tab.key ? "active" : ""}`} onClick={() => setActiveTab(tab.key)}>
                {tab.label}
              </button>
            ))}
          </nav>
          <div className="od-navbar-right">
            {/* CRM Button */}
            <button
              className="od-crm-btn"
              onClick={() => {

                // Get user data from localStorage
                const username = localStorage.getItem('username');
                const password = localStorage.getItem('password');

                // Create data object to encrypt
                const authData = {
                  username: username,
                  password: password,
                  timestamp: Date.now() // Optional: Add timestamp for extra security
                };

                // Encrypt the data
                const encryptedData = encryptData(authData);

                // Prepare query params with encrypted data
                const params = new URLSearchParams();
                params.set('algn', encryptedData);

                console.log('CRM Params (encrypted):', params.toString());
                console.log('Original data:', authData);

                // Redirect with encrypted query params
                const CrmUrl = `${environment.crmUrl}/?${params.toString()}`;
                window.open(CrmUrl, '_blank', 'noopener,noreferrer');
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
                <polyline points="15 3 21 3 21 9" />
                <line x1="10" y1="14" x2="21" y2="3" />
              </svg>
              CRM
            </button>

            <button className="od-logout-btn" onClick={handleLogoutClick}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
              </svg>
              Logout
            </button>
          </div>
        </div>
      </header>

      <div className="od-tab-bar">
        <div className="od-tab-bar-inner">
          {NAV_TABS.map((tab) => (
            <button key={tab.key} className={`od-tab-bar-item ${activeTab === tab.key ? "active" : ""}`} onClick={() => setActiveTab(tab.key)}>
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <main className="od-main">
        <div className="od-container">
          <div className="od-page-header">
            <div>
              {selectedPG && (
                <h1
                  className="od-page-title"
                  onClick={() => {
                    const slug = selectedPG.PGName
                      .toLowerCase()
                      .replace(/[^a-z0-9]+/g, '-')
                      .replace(/^-+|-+$/g, '');

                    navigate(`/pg/${slug}-${selectedPG.PGID}`, {
                      state: {
                        PGNAME: selectedPG.PGName,
                        PGID: selectedPG.PGID
                      }
                    });
                  }}
                >
                  {selectedPG.PGName}
                </h1>
              )}
              <p className="od-page-sub">{NAV_TABS.find((t) => t.key === activeTab)?.label}</p>
            </div>

            {/* PG Selector with empty state handling */}
            <div className={`od-pg-selector ${pgMenuOpen ? "open" : ""}`}>
              <button className="od-pg-trigger" onClick={() => setPgMenuOpen((p) => !p)}>

                <svg width="20" height="20" viewBox="0 0 26 26" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
                  <rect x="5" y="9" width="16" height="14" rx="1" ry="1" />
                  <polygon points="4,9 13,3 22,9" />
                  <line x1="8" y1="13" x2="8" y2="19" />
                  <line x1="13" y1="13" x2="13" y2="19" />
                  <line x1="18" y1="13" x2="18" y2="19" />
                  <line x1="9" y1="9" x2="9" y2="6" />
                  <line x1="13" y1="9" x2="13" y2="6" />
                  <line x1="17" y1="9" x2="17" y2="6" />
                </svg>

                {selectedPG?.PGName || (pgList.length === 0 ? 'No PG registered' : 'Select PG')}
                <svg width="13" height="13" viewBox="0 0 14 14" fill="none" className="od-pg-chevron">
                  <path d="M3 5L7 9L11 5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                </svg>
              </button>
              {pgMenuOpen && (
                <div className="od-pg-menu">
                  {pgList.length > 0 ? (
                    pgList.map((pg) => (
                      <button
                        key={pg.PGID}
                        className={`od-pg-item ${selectedPG?.PGID === pg.PGID ? "selected" : ""}`}
                        onClick={() => { setSelectedPG(pg); setPgMenuOpen(false); }}
                      >
                        {selectedPG?.PGID === pg.PGID && (
                          <svg className="svg-sel" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M2 6L5 9L10 3" stroke="#F06E18" strokeWidth="2" strokeLinecap="round" />
                          </svg>
                        )}
                        {pg.PGName}
                      </button>
                    ))
                  ) : (
                    <div className="od-pg-empty">
                      <p>No PGs registered yet</p>
                      <button className="od-pg-add-btn" onClick={() => setAddPGModalOpen(true)}>
                        + Add PG
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>

          </div>

          {activeTab === "occupancy" && <OwnerOccupancy
            selectedPG={selectedPG?.PGName}
            selectedPGId={selectedPG?.PGID}
            onVacantClick={openAddTenant}
          />}
          {activeTab === "planning" && (
            <OwnerPlanning
              selectedPG={selectedPG?.PGName}
              selectedPGId={selectedPG?.PGID}
            />
          )}
          {activeTab === "revenue" && (
            <OwnerRevenue
              selectedPG={selectedPG?.PGName}
              selectedPGId={selectedPG?.PGID}
            />
          )}
          {activeTab === "complaints" && (
            <OwnerComplaints
              selectedPG={selectedPG?.PGName}
              selectedPGId={selectedPG?.PGID}
            />
          )}
          {activeTab === "compliance" && (
            <OwnerCompliance
              selectedPG={selectedPG?.PGName}
              selectedPGId={selectedPG?.PGID}
            />
          )}
          {activeTab === "reports" && (
            <OwnerReports
              selectedPG={selectedPG?.PGName}
              selectedPGId={selectedPG?.PGID}
            />
          )}

          {activeTab === "dashboard" && (
            <>
              {/* Loading State for Dashboard Data */}
              {loadingDashboard && (
                <div className="od-loading-state">
                  <div className="od-spinner"></div>
                  <p>Loading dashboard data...</p>
                </div>
              )}

              {/* Error State */}
              {dashboardError && !loadingDashboard && (
                <div className="od-error-state">
                  <p>Error: {dashboardError}</p>
                  <button onClick={() => fetchDashboardData(selectedPG?.PGID)} className="od-retry-btn">Retry</button>
                </div>
              )}

              {/* Stat Cards - Only show if data is loaded */}
              {!loadingDashboard && !dashboardError && dashboardData && (
                <div className="od-stats-grid">
                  {STATS.map((stat) => (
                    <div key={stat.key} className="od-stat-card od-stat-card-clickable" onClick={() => { if (["occupancy", "revenue", "complaints", "compliance"].includes(stat.key)) setActiveTab(stat.key); }}>
                      <div className="od-stat-top">
                        <span className="od-stat-label">{stat.label}</span>
                        <span className="od-stat-icon" style={{ background: stat.iconBg, color: stat.iconColor }}>{stat.icon}</span>
                      </div>
                      <div className="od-stat-value">{stat.value}</div>
                      <div className="od-stat-bar-track">
                        <div className="od-stat-bar-fill" style={{ width: `${stat.bar}%`, background: stat.color }} />
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* ── Verify Tenants ── */}
              {!isSupportingStaff && pgList.length > 0 &&
                <>
                  {pendingTenants.length > 0 ? (
                    <div className="od-section od-verify-section">
                      <div className="od-verify-head">
                        <div className="od-verify-title-row">
                          <h2 className="od-section-title od-section-title-inline">Verify Tenants</h2>
                          <span className="od-verify-badge">{pendingTenants.length}</span>
                        </div>
                        <p className="od-verify-sub">Review submitted forms and verify tenants before assigning rooms.</p>
                      </div>
                      <div className="od-vt-table">
                        <div className="od-vt-head">
                          <div className="od-vt-cell od-vt-name">Name</div>
                          <div className="od-vt-cell od-vt-phone">Phone</div>
                          <div className="od-vt-cell od-vt-email">Email</div>
                          <div className="od-vt-cell od-vt-checkin">Check-in</div>
                          <div className="od-vt-cell od-vt-status-col">Agreement Status</div>
                          <div className="od-vt-cell od-vt-actions">Actions</div>
                        </div>
                        {pendingTenants.map((t) => (
                          <div key={t.TenantID} className="od-vt-row">
                            <div className="od-vt-cell od-vt-name"><span className="od-vt-name-text">{t.TenantName}</span></div>
                            <div className="od-vt-cell od-vt-phone">{t.PhoneNumber}</div>
                            <div className="od-vt-cell od-vt-email od-vt-email-clip">{t.Email1 || "—"}</div>
                            <div className="od-vt-cell od-vt-checkin">{t.CheckInDate ? formatDateToDDMMYYYY(t.CheckInDate) : "—"}</div>


                            <div className="od-vt-cell od-vt-status-col">
                              <span className={`od-vt-status ${t.AgreementStatus === "TENANT_ACCEPTED" ? 'status-accepted' :
                                t.AgreementStatus === "REJECTED" ? 'status-rejected' :
                                  t.AgreementStatus === "DRAFT" ? 'status-draft' : ''
                                }`}>
                                {t.AgreementStatus === "TENANT_ACCEPTED" ? "Accepted" :
                                  t.AgreementStatus === "REJECTED" ? "Rejected" :
                                    t.AgreementStatus === "DRAFT" ? "Draft" :
                                      t.AgreementStatus === "Generate" ? "Not Generated" : "N/A"}
                              </span>
                            </div>

                            <div className="od-vt-cell od-vt-actions">
                              {/* 
                              <span className={`od-vt-status ${t.AgreementStatus === "TENANT_ACCEPTED" ? 'status-accepted' :
                                  t.AgreementStatus === "REJECTED" ? 'status-rejected' :
                                    t.AgreementStatus === "DRAFT" ? 'status-draft' : ''
                                }`}>
                                {t.AgreementStatus === "TENANT_ACCEPTED" ? "Accepted" :
                                  t.AgreementStatus === "REJECTED" ? "Rejected" :
                                    t.AgreementStatus === "DRAFT" ? "Draft" :
                                      t.AgreementStatus || "N/A"}
                              </span> */}
                              {/* {t.AgreementStatus == "Generate" ?
                                <button
                                  className="od-vt-btn od-vt-btn-view"
                                  onClick={() => handleAgreementClick(t)}
                                >
                                  Generate
                                </button>
                                :

                                <span className={`od-vt-status ${t.AgreementStatus === "TENANT_ACCEPTED" ? 'status-accepted' : 'status-rejected'}`}>
                                  {t.AgreementStatus === "TENANT_ACCEPTED" ? "Accepted" :
                                    t.AgreementStatus === "REJECTED" ? "Rejected" :
                                      t.AgreementStatus === "DRAFT" ? "Draft" :
                                        t.AgreementStatus || "Pending"}
                                </span>
                              } */}
                              <button
                                className="od-vt-btn od-vt-btn-view"
                                onClick={() => setReviewTenant(t)}
                              >
                                View Form
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    !loadingTenants && (
                      <div className="od-section od-empty-section">
                        <div className="od-empty-state">
                          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5">
                            <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                            <circle cx="9" cy="7" r="4" />
                            <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
                          </svg>
                          <h3 className="od-empty-title">No tenants to verify</h3>
                          <p className="od-empty-sub">PG owner to allocate beds when tenant apply</p>
                        </div>
                      </div>
                    )
                  )}
                </>
              }

              {/* Loading state for tenants */}
              {loadingTenants && (
                <div className="od-loading-state">
                  <div className="od-spinner"></div>
                  <p>Loading new tenants...</p>
                </div>
              )}

              {/* Error state */}
              {tenantsError && !loadingTenants && (
                <div className="od-error-state">
                  <p>Error: {tenantsError}</p>
                  <button onClick={() => fetchNewTenants(selectedPG?.PGID)} className="od-retry-btn">Retry</button>
                </div>
              )}

              {/* ── Quick Actions ── */}
              {!isSupportingStaff && (
                <div className="od-section">
                  <h2 className="od-section-title">Quick Actions</h2>
                  <div className="od-actions-grid">
                    {QUICK_ACTIONS.map((action) => (
                      <button key={action.key} className="od-action-card" onClick={() => {
                        // Check if there are no PGs registered
                        const hasNoPG = pgList.length === 0;

                        if (hasNoPG && action.key !== "add_pg") {
                          setShowNoPGWarning(true);
                          return;
                        }

                        if (action.key === "add_tenant") openAddTenant();
                        if (action.key === "add_pg") setAddPGModalOpen(true);
                        if (action.key === "add_room") setAddRoomModalOpen(true);
                        if (action.key === "add_bed") setAddBedModalOpen(true);
                        if (action.key === "add_electricity") setAddElectricityModalOpen(true);
                        if (action.key === "pg_layout") {
                          if (!selectedPG) {
                            setShowNoPGWarning(true);
                            return;
                          }
                          setIsLayoutModalOpen(true);
                        }
                        if (action.key === "add_pg_photos") {
                          if (!selectedPG) {
                            setShowNoPGWarning(true);
                            return;
                          }
                          setAddPGPhotosModalOpen(true);
                        }

                        if (action.key === "add_food_menu") {
                          if (!selectedPG) {
                            setShowNoPGWarning(true);
                            return;
                          }
                          setFoodMenuModalOpen(true);
                        }
                        if (action.key === "add_expense") {
                          if (!selectedPG) {
                            setShowNoPGWarning(true);
                            return;
                          }
                          setAddExpenseModalOpen(true);
                        }
                      }}>
                        <span className="od-action-icon">{action.icon}</span>
                        <span className="od-action-label">{action.label}</span>
                      </button>
                    ))}
                  </div>
                </div>

              )}
            </>
          )}
        </div>
      </main>
    </div>
  );
};

export default OwnerDashboard;